/**
 * Greeting Card Customizer
 */
class GreetingCardCustomizer {
  constructor(id, handle) {
    this.id = id;
    this.productHandle = handle;
    this.currentStep = 1;
    this.totalSteps = 4;
    this.selectedTemplate = null;
    this.uploadedPhoto = null;
    // Crop: the upload as received, what has been baked into uploadedPhoto,
    // and the cropper's state while it is open (see the Crop section).
    this.originalPhoto = null;
    this._cropBakedRotation = 0;
    this.cropRect = null;
    this._crop = null;
    this.hasPhoto = false;
    this.customMessage = '';
    this.rotation = 0;
    this.zoom = 100;
    this.photoPosition = { x: 0, y: 0 };
    // Blank cards only: 'cover' fills the panel (photos), 'contain' shows the
    // whole image (logos). Artwork slots always cover.
    this.blankFitMode = 'cover';
    this.isDragging = false;
    this.dragStart = { x: 0, y: 0 };
    this.productData = null;
    this.cachedOverlay = null;
    this._previewSeq = 0;

    // Categories the date sort must keep at the front, in this order.
    this.pinnedCategories = ['blank'];

    this.categories = [
      { key: 'blank', label: 'Blank' },
      { key: 'valentines_day', label: "Valentine's Day | Feb. 14" },
      { key: 'birthday', label: 'Birthday' },
      { key: 'thank_you', label: 'Thank You' },
      { key: 'anniversary', label: 'Anniversary' },
      { key: 'mothers_day', label: "Mother's Day" },
      { key: 'thinking_of_you', label: 'Thinking of You' },
      { key: 'christmas', label: 'Christmas' },
      { key: 'new_year', label: 'Happy New Year' },
      { key: 'sympathy', label: 'Sympathy' },
      { key: 'welcome', label: 'Welcome' },
      { key: 'easter', label: 'Easter' },
      { key: 'congratulations', label: 'Congratulations' },
      { key: 'best_wishes', label: 'Best Wishes' },
      { key: 'halloween', label: 'Halloween' },
      { key: 'thanksgiving', label: 'Thanksgiving' },
      { key: 'fathers_day', label: "Father's Day" },
      { key: 'july_4th', label: 'July 4th' },
      { key: 'labor_day', label: 'Labor Day' },
      { key: 'get_well', label: 'Get Well Soon' },
      { key: 'apology', label: 'Apology / Sorry' },
      { key: 'employee_appreciation', label: 'Employee Appreciation' },
      { key: 'new_baby', label: 'New Baby' },
      { key: 'graduation', label: 'Graduation' },
      { key: 'memorial_day', label: 'Memorial Day' },
      { key: 'photocard', label: 'Photo Card' }
    ];

    this.templates = [
      {
        id: 'anniv-wreath-1',
        name: 'Happy Anniversary Wreath',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/1.png?v=108686647188777466771773417676',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'sympathy-daffodils-2',
        name: 'With Deepest Sympathy',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/2.png?v=159285952353131005281773417716',
        canCustom: false,
        type: 'sympathy',
        orientation: 'portrait'
      },
      {
        id: 'xmas-lights-4',
        name: 'Merry Christmas Lights',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/4.png?v=109568940067703718921773417726',
        canCustom: false,
        type: 'christmas',
        orientation: 'portrait'
      },
      {
        id: 'thank-blue-5',
        name: 'Thank You Blue Floral',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/5.png?v=71462415920479722811773417731',
        canCustom: false,
        type: 'thank_you',
        orientation: 'portrait'
      },
      {
        id: 'val-pink-6',
        name: 'Happy Valentine\'s Flowers',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/val-6.png?v=165917383095935390571773417791',
        canCustom: false,
        type: 'valentines_day',
        orientation: 'portrait'
      },
      {
        id: 'welcome-floral-7',
        name: 'Welcome Blue Floral',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/7.png?v=56865925649522382071773417736',
        canCustom: false,
        type: 'welcome',
        orientation: 'portrait'
      },
      {
        id: 'easter-spring-8',
        name: 'Bright Spring Easter',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/8.png?v=149538052865619393841773417737',
        canCustom: false,
        type: 'easter',
        orientation: 'portrait'
      },
      {
        id: 'val-cherry-9',
        name: 'Love You Cherry Much',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/9.png?v=158264350390743629611773417744',
        canCustom: false,
        type: 'valentines_day',
        orientation: 'portrait'
      },
      {
        id: 'congrats-red-10',
        name: 'Congrats Red Swirl',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/10.png?v=57645057506066505251773417679',
        canCustom: false,
        type: 'congratulations',
        orientation: 'portrait'
      },
      {
        id: 'best-wishes-11',
        name: 'Best Wishes',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/11.png?v=179400078194586412351773417682',
        canCustom: false,
        type: 'best_wishes',
        orientation: 'portrait'
      },
      {
        id: 'easter-eggs-12',
        name: 'Happy Easter Eggs',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/12.png?v=8462634203560842201773417686',
        canCustom: false,
        type: 'easter',
        orientation: 'portrait'
      },
      {
        id: 'anniv-blue-13',
        name: 'Anniversary Blue Floral',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/13.png?v=172286608333836425341773417690',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'hall-house-14',
        name: 'Happy Halloween House',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/14.png?v=104535568805262713791773417692',
        canCustom: false,
        type: 'halloween',
        orientation: 'portrait'
      },
      {
        id: 'fathers-day-15',
        name: 'Happy Father\'s Day Silhouette',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/15.png?v=126942582310773105541773417695',
        canCustom: true,
        type: 'fathers_day',
        orientation: 'portrait'
      },
      {
        id: 'mom-pink-16',
        name: 'Happy Mother\'s Day Sky',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/16.png?v=147104720326333515661773417701',
        canCustom: false,
        type: 'mothers_day',
        orientation: 'portrait'
      },
      {
        id: 'get-well-17',
        name: 'Get Well Soon Floral',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/17.png?v=28151538683742246421773417704',
        canCustom: false,
        type: 'get_well',
        orientation: 'landscape'
      },
      {
        id: 'bday-balloons-18',
        name: 'Happy Birthday Balloons',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/18.png?v=134096148919971045561773417709',
        canCustom: false,
        type: 'birthday',
        orientation: 'landscape'
      },
      {
        id: 'sorry-sign-19',
        name: 'I\'m Really Sorry Sign',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/19.png?v=7247562893161320221773417711',
        canCustom: false,
        type: 'apology',
        orientation: 'landscape'
      },
      {
        id: 'congrats-watercolor-20',
        name: 'Congratulations Watercolor',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/20.png?v=15790464996143251731773417719',
        canCustom: false,
        type: 'congratulations',
        orientation: 'landscape'
      },
      {
        id: 'anniv-you-me-01',
        name: 'You & Me Always Dancing',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_01.jpg?v=113687542510359234841773417746',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'anniv-forever-02',
        name: 'Forever With You Hearts',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_02.jpg?v=67416870141038477251773417748',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'anniv-still-in-love-03',
        name: 'Still In Love',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_03.jpg?v=30424578444695729671773417750',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'anniv-puzzle-04',
        name: 'Me & You Puzzle Heart',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_04.jpg?v=136095190905239006531773417752',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'anniv-always-you-05',
        name: 'Always You Heart Pattern',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_05.jpg?v=171084802089318972831773417755',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'anniv-cute-birds-06',
        name: 'Still Cute Love Birds',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Anniversary_06.jpg?v=65069978415359284941773417756',
        canCustom: false,
        type: 'anniversary',
        orientation: 'portrait'
      },
      {
        id: 'bday-gifts-01',
        name: 'Dog Happy Birthday',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_01.jpg?v=142284376030167212261773417758',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-gifts-02',
        name: 'Happy Birthday Gifts & Balloons',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_02.jpg?v=8205906744306152301773417760',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-pawsome-03',
        name: 'Pawsome Cat Birthday',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_03.jpg?v=108156009385758965911773417762',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-flower-04',
        name: 'Just For You Flower',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_04.jpg?v=1955348177233125591773417764',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-celebrate-you-05',
        name: 'Celebrate You Balloons',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_05.jpg?v=161584434693804626901773417766',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-cake-first-06',
        name: 'But Cake First Characters',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_06.jpg?v=88333880126985350651773417768',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'bday-cake-party-07',
        name: 'But Cake First Kids Party',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Birthday_07.jpg?v=184281991124866561511773417770',
        canCustom: false,
        type: 'birthday',
        orientation: 'portrait'
      },
      {
        id: 'emp-thank-you-01',
        name: 'Thank You Orchid',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_01.jpg?v=21022819711084855611773417772',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'emp-piece-difference-02',
        name: 'Piece That Made The Difference',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_02.jpg?v=175601429979118405751773417774',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'emp-grow-03',
        name: 'Help Great Things Grow Brain',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_03.jpg?v=128903665699225244211773417776',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'emp-positivity-04',
        name: 'Positivity Spreads Workspace',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_04.jpg?v=175518984771962755711773417778',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'emp-work-better-dark-05',
        name: 'You Make Work Better Dark',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_05.jpg?v=39249906734826548231773417780',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'emp-work-better-light-06',
        name: 'You Make Work Better Light',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/Employee_06.jpg?v=147356969147087285251773417782',
        canCustom: false,
        type: 'employee_appreciation',
        orientation: 'portrait'
      },
      {
        id: 'baby-stork-01',
        name: 'Delivery On Way Stork',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/New%20baby_01.JPG?v=103636162723240143141773405749',
        canCustom: false,
        type: 'new_baby',
        orientation: 'portrait'
      },
      {
        id: 'baby-on-way-02',
        name: 'Baby On The Way Clouds',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/New%20baby_02.jpg?v=103239272269269675731773405749',
        canCustom: false,
        type: 'new_baby',
        orientation: 'portrait'
      },
      {
        id: 'baby-twins-03',
        name: 'Double The Joy Twins',
        overlayImage: '//millicanpecan.com/cdn/shop/t/38/assets/New%20baby_03.jpg?v=78136139781866018051773405747',
        canCustom: false,
        type: 'new_baby',
        orientation: 'portrait'
      }
    ];

    // Normalize legacy templates to the unified shape so new-gift code paths
    // can rely on the same fields. hasPhoto mirrors canCustom; the rest are null.
    this.templates = this.templates.map(t => ({
      ...t,
      source: 'legacy',
      hasPhoto: t.canCustom,
      photoSlot: null,
      bakedText: null,
      canvas: null
    }));

    // Blank cards: no artwork, the shopper's photo (or logo) fills the front.
    // They ride the new-gift slot pipeline with a slot the size of the inner
    // panel, so the 152px white printer margin stays consistent with every
    // artwork card and nothing lands in the printer's non-printable edge.
    // overlayImage is null: every render path must treat that as "no art".
    const blankCard = (orientation) => {
      const landscape = orientation === 'landscape';
      const w = landscape ? 5100 : 3300;
      const h = landscape ? 3300 : 5100;
      const margin = 152;
      return {
        id: landscape ? 'blank-horizontal' : 'blank-vertical',
        name: landscape ? 'Horizontal' : 'Vertical',
        subtitle: 'Blank or add photo',
        cartName: landscape ? 'Blank Card (Horizontal)' : 'Blank Card (Vertical)',
        overlayImage: null,
        canCustom: true,
        type: 'blank',
        orientation,
        source: 'blank',
        hasPhoto: true,
        photoSlot: {
          shape: 'rectangle',
          center: { x: w / 2, y: h / 2 },
          size: { width: w - margin * 2, height: h - margin * 2 },
          rotation: 0
        },
        bakedText: null,
        canvas: { width: w, height: h, margin, dpi: 600 }
      };
    };
    this.templates.push(blankCard('landscape'), blankCard('portrait'));

    // Base URL for new-gift card overlay images. Files in new-gift.json reference
    // paths like "birthday/b01-...jpg"; we flatten to the basename and prepend this base.
    // Points at Shopify "Content > Files" CDN. The "?v=..." cache-buster on individual
    // file URLs is omitted; Shopify serves files fine without it.
    this.newGiftCdnBase = 'https://cdn.shopify.com/s/files/1/0081/9091/8716/files/';

    // Multiplier applied to every new-gift photoSlot's width and height before
    // clipping and cover-fitting. The slots in new-gift.json are measured from
    // the finished artwork (card design/_tool/measure_photo_slots.py) and
    // already include a small overlap under the frame line, so no inflation is
    // applied. This used to be 1.15 to paper over guessed slots, which made
    // photos spill past small frames while still leaving big frames unfilled.
    this.slotInflation = 1;

    // Print output resolution.
    //
    // The front/back images uploaded to the API are the exact bytes the shop's
    // printer later pulls from S3 and puts on 5.5x8.5 stock. Nothing on the
    // server resamples them (imageService.js exists but is not wired into the
    // create_giftcard path), so whatever is rendered here is what gets printed.
    // These are therefore rendered at the artwork's own authoring resolution,
    // 600 DPI / 3300x5100, instead of the on-screen preview's 400x600.
    //
    // Used only for legacy templates, which carry no canvas block. New-gift
    // cards use their own canvas dimensions from new-gift.json.
    this.printLongEdge = 5100;  // 8.5in at 600 DPI
    this.printShortEdge = 3300; // 5.5in at 600 DPI

    // Budget for the whole upload request, not per file. Two limits apply and
    // the tighter one is nginx: location /api/ sets client_max_body_size 10M,
    // which covers front + back + form fields in one multipart request. (multer
    // separately caps each file at 10MB, mirrored in imageValidator.)
    //
    // Best effort, not a guarantee: quality steps down through the list below
    // and if even the lowest step overshoots, the image is sent anyway with a
    // console warning, because compressing further would mean giving up print
    // resolution. A 3300x5100 card has a floor of roughly 1.9MB whatever the
    // quality.
    //
    // This budget does bind on the worst cards. Measured with a photo of pure
    // random noise (less compressible than any real photograph) on the largest
    // photo slots in the catalogue, which cover 37.7% of a landscape card:
    // front 7.7MB + back 1.3MB = 8.96MB, i.e. the step-down engaged and held
    // the pair just inside this budget, about 1MB short of the nginx cap.
    // Ordinary photographs land far lower (a real test card totalled 2.5MB).
    // If cards ever start arriving visibly soft, raise this and nginx together
    // rather than lowering the resolution.
    this.printMaxBytes = 9 * 1024 * 1024;
    this.printQualitySteps = [0.95, 0.9, 0.85, 0.8, 0.72];

    // Fresh uploads. The photo file itself never leaves the browser (only the
    // rendered card front and back are uploaded), so this cap only stops a
    // phone from trying to decode something absurd. Modern phone photos are
    // 3-8MB JPEGs (24MP iPhones convert HEIC to JPEG on the fly for web
    // uploads) and iPhone screenshots are 5-15MB PNGs; the old 5MB cap turned
    // both away with a bare alert().
    this.maxUploadBytes = 50 * 1024 * 1024;
    // Long-edge cap applied after decoding. The biggest print slot is 5100px
    // across, so a larger photo gains nothing in print, and a 48MP shot would
    // cost ~200MB of canvas memory on a phone.
    this.maxPhotoEdge = 6000;
    // Every canvas sized from the photo has to fit this. iOS Safari refuses to
    // back a canvas larger than 2^24 pixels and hands back a blank one instead,
    // so a 24MP phone shot would open an empty cropper on an iPhone.
    this.maxCanvasPixels = 16.7e6;

    this.aiConfig = {
      enabled: false,
      endpoint: '',
      recaptchaKey: ''
    };
    this.uploadApiEndpoint = '';
    this.selectedCommands = [];
    this.isAIProcessing = false;

    // Text box positioning (percentage-based, centered by default)
    this.textBoxPosition = { x: 50, y: 50 }; // Center of card
    this.textBoxSize = { width: 88, height: 75 }; // Size in percentage of canvas
    this.isTextBoxDragging = false;
    this.isTextBoxResizing = false;
    this.resizeDirection = null;
    this.textBoxDragStart = { x: 0, y: 0 };
    this.textBoxResizeStart = { x: 0, y: 0, width: 0, height: 0, posX: 0, posY: 0 };

    // Default messages for each gift card type (10 options each — one is picked randomly on template select)
    this.defaultMessages = {

      valentines_day: [
        "To my dearest love,\n\nYou make every day brighter and every moment more meaningful. Thank you for being you.\n\nWith all my love",
        "Happy Valentine's Day!\n\nEvery moment with you feels like a gift. You are my favorite person in the whole world.\n\nForever yours",
        "My love,\n\nWords can barely capture how much you mean to me. You are my heart, my home, my everything.\n\nAlways and forever",
        "To the one who makes my heart smile,\n\nThank you for your warmth, your laughter, and your endless love. I am so lucky to have you.\n\nWith all my heart",
        "Happy Valentine's Day!\n\nLoving you is the best thing that ever happened to me. Here's to us and all the beautiful moments ahead.\n\nYours always",
        "Dearest,\n\nYou are my sunshine on cloudy days and my calm in every storm. I love you more than words can say.\n\nWith love",
        "To my Valentine,\n\nEvery day with you is a day worth celebrating. Thank you for choosing me, again and again.\n\nAll my love",
        "My heart,\n\nI fall for you more with each passing day. You are my greatest adventure and my sweetest comfort.\n\nForever in love",
        "Happy Valentine's Day!\n\nBeing with you makes the ordinary feel extraordinary. Thank you for filling my life with so much joy.\n\nWith endless love",
        "To the love of my life,\n\nYou are everything I never knew I needed and everything I will always want. Happy Valentine's Day.\n\nYours completely"
      ],

      birthday: [
        "Happy Birthday!\n\nWishing you a day filled with joy, laughter, and all the things that make you smile.\n\nCheers to another amazing year!",
        "Happy Birthday!\n\nMay this year bring you everything you have been hoping for. You deserve all the happiness in the world.\n\nWith love",
        "Wishing you the happiest of birthdays!\n\nYou bring so much light to everyone around you. Today is all about celebrating YOU.\n\nWith warmest wishes",
        "Happy Birthday!\n\nAnother year older, another year wiser, and another year more wonderful. Here's to you!\n\nCheers!",
        "To the birthday star!\n\nMay your day be as bright and amazing as you are. Enjoy every single moment.\n\nWith love and celebration",
        "Happy Birthday!\n\nYou are one of a kind, and the world is so much better with you in it. Have the most incredible day.\n\nWith all my heart",
        "Wishing you a truly special birthday!\n\nMay the joy you bring to others come back to you tenfold today and always.\n\nWith warmest wishes",
        "Happy Birthday!\n\nHere's to a year full of new adventures, big dreams, and all the cake you can eat!\n\nCelebrating you",
        "To someone who deserves the world!\n\nHappy Birthday! May this year exceed all your expectations and bring you pure happiness.\n\nWith love",
        "Happy Birthday!\n\nTime flies when you're this wonderful. Thank you for being such an incredible person in my life.\n\nWishing you all the best"
      ],

      thank_you: [
        "Thank You!\n\nYour kindness and generosity mean more than words can express. I am truly grateful.\n\nWith sincere appreciation",
        "Thank You!\n\nWhat you did made such a difference in my life. Your thoughtfulness will never be forgotten.\n\nWith gratitude",
        "From the bottom of my heart, thank you.\n\nYour support and generosity have meant the world to me. I am so grateful to have you.\n\nWith appreciation",
        "Thank You!\n\nKindness like yours is rare and beautiful. I feel so lucky to be on the receiving end of it.\n\nWith heartfelt thanks",
        "A heartfelt thank you!\n\nYou went above and beyond, and I will never forget your incredible generosity.\n\nWith much gratitude",
        "Thank You!\n\nYour thoughtfulness truly touched my heart. Please know how deeply appreciated you are.\n\nWith warm thanks",
        "Words feel small, but thank you.\n\nWhat you did was extraordinary. Your generosity has left a lasting impression on me.\n\nWith sincerest thanks",
        "Thank You!\n\nYou are one of the most generous and thoughtful people I know. This gift means more than you realize.\n\nWith love and gratitude",
        "Thank you so much!\n\nYour kindness made a hard moment easier and a happy moment even better. I am so grateful.\n\nWith appreciation",
        "Thank You!\n\nYour support has been a true blessing. I am endlessly grateful for you and everything you do.\n\nWith love"
      ],

      anniversary: [
        "Happy Anniversary!\n\nCelebrating the beautiful journey we've shared together. Here's to many more wonderful years.\n\nWith love always",
        "Happy Anniversary!\n\nEvery year with you is better than the last. Thank you for being my partner, my best friend, my everything.\n\nForever yours",
        "To my love on our anniversary,\n\nWhat a journey it has been. I would choose you again and again, in every lifetime.\n\nWith all my heart",
        "Happy Anniversary!\n\nYou are the greatest adventure of my life. Here's to all the chapters still ahead of us.\n\nWith endless love",
        "Another year of loving you,\n\nAnd I fall in love all over again each day. Thank you for everything you are to me.\n\nAlways",
        "Happy Anniversary!\n\nWhen I look back on our years together, all I see is how blessed I am. Here's to us.\n\nWith love",
        "To the one who makes every ordinary day feel like a celebration,\n\nHappy Anniversary. I love you more with every passing year.\n\nYours forever",
        "Happy Anniversary!\n\nA love like ours is rare, and I treasure every single moment of it. You are my greatest gift.\n\nWith all my love",
        "Celebrating you, and us, and everything we've built together.\n\nHappy Anniversary. I could not imagine this life with anyone else.\n\nWith love always",
        "Happy Anniversary!\n\nHere's to the years behind us that shaped us, and the years ahead that await us. Thank you for being mine.\n\nForever in love"
      ],

      mothers_day: [
        "Happy Mother's Day!\n\nThank you for your endless love, support, and everything you do. You are truly amazing.\n\nWith all my love",
        "Happy Mother's Day!\n\nNo words are enough to thank you for all you have given me. You are my greatest role model.\n\nWith love",
        "To the world's most wonderful mom,\n\nThank you for your strength, your warmth, and your unwavering love. Today is all about you.\n\nWith all my heart",
        "Happy Mother's Day!\n\nYou have always been my safe place and my biggest cheerleader. I am so grateful to call you mom.\n\nWith love always",
        "Mom,\n\nEverything good in me I learned from you. Thank you for your love, your patience, and your wisdom.\n\nForever grateful",
        "Happy Mother's Day!\n\nYou make motherhood look like the most beautiful thing in the world. Thank you for being you.\n\nWith all my love",
        "To the woman who does it all,\n\nYour love has shaped me in ways I am still discovering. Thank you for everything, Mom.\n\nWith love",
        "Happy Mother's Day!\n\nYou have always believed in me, even when I didn't believe in myself. That means everything.\n\nWith gratitude and love",
        "Mom,\n\nThank you for every sacrifice you made and every moment of love you gave. You are my hero.\n\nWith all my heart",
        "Happy Mother's Day!\n\nBeing loved by you is the greatest gift. Thank you for making home the warmest place in the world.\n\nWith love"
      ],

      thinking_of_you: [
        "Thinking of You\n\nJust wanted you to know that you're in my thoughts and heart today.\n\nSending warm wishes your way",
        "Thinking of You\n\nDistance may keep us apart, but you are never far from my thoughts. Sending you love and warmth today.\n\nWith care",
        "Just thinking of you today.\n\nI hope this little reminder brings a smile to your face. You mean so much to me.\n\nWith love",
        "Thinking of You\n\nLife gets busy, but some people never leave your heart. You are always on my mind.\n\nSending warmth",
        "Sending you a warm hello.\n\nI was thinking of you today and wanted you to know how much you mean to me.\n\nWith care and love",
        "Thinking of You\n\nYou are a wonderful person, and I hope your days are as bright as the joy you bring to others.\n\nWarm thoughts",
        "A little note to say I'm thinking of you.\n\nHope this finds you well and surrounded by everything that makes you happy.\n\nWith warmth",
        "Thinking of You\n\nSomething reminded me of you today, and I just had to reach out. You're never far from my heart.\n\nWith love",
        "You crossed my mind today.\n\nAnd I realized how grateful I am to have someone like you in my life.\n\nSending warm thoughts",
        "Thinking of You\n\nI hope today is gentle and good to you. You deserve all the happiness coming your way.\n\nWith care"
      ],

      christmas: [
        "Merry Christmas!\n\nMay your holidays be filled with warmth, joy, and cherished moments with loved ones.\n\nBest wishes for the New Year",
        "Merry Christmas!\n\nWishing you a season full of peace, laughter, and all the magic that this time of year brings.\n\nWith love",
        "Season's Greetings!\n\nMay your home be filled with the warmth of family, the joy of the season, and the sweetness of good food.\n\nMerry Christmas",
        "Merry Christmas!\n\nThank you for being such a wonderful part of my life. Wishing you a holiday season as special as you are.\n\nWith love",
        "Wishing you a beautiful Christmas!\n\nMay this holiday season bring rest, joy, and all the things that fill your heart with happiness.\n\nSeasonal blessings",
        "Merry Christmas!\n\nMay your days be merry, your nights be bright, and your heart be full this holiday season.\n\nWith warmth",
        "Season's Greetings!\n\nSending you love and best wishes this Christmas. May the New Year bring you everything you hope for.\n\nWith joy",
        "Merry Christmas!\n\nHere's hoping your holidays are wrapped in love and filled with moments you'll treasure forever.\n\nWith warmth and cheer",
        "Wishing you peace, joy, and love this Christmas season.\n\nMay the new year ahead bring fresh beginnings and wonderful things.\n\nMerry Christmas",
        "Merry Christmas!\n\nThank you for everything you bring to my life. This season, I am especially grateful for you.\n\nWith love and warm wishes"
      ],

      sympathy: [
        "With Deepest Sympathy\n\nPlease know that you are in my thoughts and heart during this difficult time. I am so sorry for your loss.\n\nWith love",
        "With Heartfelt Sympathy\n\nThere are no words that can ease the pain of loss, but I hope you feel the love surrounding you.\n\nWith care",
        "I am so deeply sorry for your loss.\n\nMay the memories you carry bring you comfort and peace in the days ahead.\n\nWith sympathy",
        "With Deepest Sympathy\n\nYour loved one was so special, and their memory will live on in all the lives they touched.\n\nWith love and condolences",
        "Please accept my sincerest condolences.\n\nMay you find comfort in the support of those around you and peace in the days to come.\n\nWith sympathy",
        "With Sympathy\n\nI am thinking of you and holding you in my heart. Please reach out if there is anything I can do.\n\nWith love",
        "So sorry for your loss.\n\nMay the love of family and friends carry you through this difficult time.\n\nWith heartfelt condolences",
        "With Deepest Sympathy\n\nGrieving with you and sending all my love. May you find moments of peace and comfort.\n\nWith care",
        "My heart goes out to you.\n\nThough words feel small, please know that you are surrounded by love and you are not alone.\n\nWith sympathy",
        "With Sympathy\n\nLoss is never easy, and there is no right way to grieve. I am here for you in whatever way you need.\n\nWith love"
      ],

      welcome: [
        "Welcome!\n\nSo happy to have you here. We hope you feel at home from the very first moment.\n\nWith warm regards",
        "Welcome!\n\nThis is the beginning of something wonderful. We are so glad you are here.\n\nWith open arms",
        "A warm welcome to you!\n\nWe hope your arrival brings as much joy to you as your presence brings to us.\n\nWith warmth",
        "Welcome!\n\nYou are going to love it here. We are so excited to have you as part of our community.\n\nWith enthusiasm",
        "Hello and welcome!\n\nWe have been looking forward to your arrival. Here is to great things ahead.\n\nWarmly",
        "Welcome!\n\nEvery great story has a beginning, and this is yours. We are thrilled to be a part of it.\n\nWith excitement",
        "So glad you are here!\n\nThis place is better with you in it. Warmest welcome and best wishes for the journey ahead.\n\nWith joy",
        "Welcome!\n\nYou are joining something truly special, and we cannot wait to grow and explore together.\n\nWith enthusiasm",
        "A heartfelt welcome to you.\n\nWe hope you feel the warmth and support that surrounds you from day one.\n\nWith warm wishes",
        "Welcome!\n\nNew beginnings are exciting, and we are honored to share this one with you. Here's to what comes next.\n\nWith warmth"
      ],

      easter: [
        "Happy Easter!\n\nWishing you a beautiful day filled with joy, renewal, and all the sweetness of the season.\n\nWith love",
        "Happy Easter!\n\nMay this joyful season bring hope and new beginnings to you and your family.\n\nWith warm wishes",
        "Wishing you a wonderful Easter!\n\nMay your day be filled with sunshine, laughter, and plenty of chocolate.\n\nWith love",
        "Happy Easter!\n\nThis season reminds us of the beauty of new beginnings. Wishing you renewal and joy.\n\nWith blessings",
        "Hoppy Easter!\n\nSending springtime cheer and all good things your way this Easter weekend.\n\nWith warmth",
        "Happy Easter!\n\nMay you be surrounded by family, filled with peace, and blessed with a truly joyful day.\n\nWith love",
        "Wishing you a bright and beautiful Easter!\n\nMay the season bring freshness, hope, and all good things to your door.\n\nWith warm wishes",
        "Happy Easter!\n\nHere's hoping your basket is full, your heart is light, and your day is absolutely wonderful.\n\nWith love",
        "Sending you Easter blessings!\n\nMay this season of renewal fill your home with happiness and your heart with peace.\n\nWith care",
        "Happy Easter!\n\nSpring is here, bringing new life and fresh hope. Wishing you a season filled with both.\n\nWith warmth"
      ],

      congratulations: [
        "Congratulations!\n\nThis achievement is no surprise to those who know how hard you have worked. You deserve every bit of this.\n\nWith pride",
        "Congratulations!\n\nWhat incredible news! Your dedication and talent have brought you to this amazing moment.\n\nWith admiration",
        "Huge congratulations to you!\n\nYou worked for this and you earned it. Celebrate big — you absolutely deserve it!\n\nWith excitement",
        "Congratulations on this incredible milestone!\n\nYour hard work, perseverance, and heart have made this possible. So proud of you.\n\nWith love",
        "Congratulations!\n\nThis is just the beginning of even greater things to come. The sky is truly the limit for you.\n\nWith enthusiasm",
        "What an achievement!\n\nCongratulations! I have watched you work so hard for this, and I could not be more proud.\n\nWith pride",
        "Congratulations!\n\nYou set your sights on a goal and you reached it. That takes real courage and commitment.\n\nWith admiration",
        "So proud of you!\n\nCongratulations on this well-deserved success. Your dedication is an inspiration to everyone around you.\n\nWith love",
        "Congratulations!\n\nBig moments like this are built from countless small acts of determination. Celebrate this one fully.\n\nWith excitement",
        "This is your moment!\n\nCongratulations on this remarkable achievement. Wishing you continued success in everything ahead.\n\nWith warmth"
      ],

      best_wishes: [
        "Best Wishes!\n\nWherever this next chapter takes you, I hope it brings everything you have been hoping for.\n\nWith warm regards",
        "Sending you all the best!\n\nMay the path ahead be bright, the journey rewarding, and the destination everything you dreamed.\n\nWith warmth",
        "Best Wishes!\n\nYou are stepping into something new with grace and courage. Wishing you every success.\n\nWith encouragement",
        "All the best to you!\n\nI am cheering you on from every corner. Whatever comes next, I know you will thrive.\n\nWith love",
        "Best Wishes!\n\nMay good things find you at every turn and may happiness follow you wherever you go.\n\nWith warm thoughts",
        "Sending you best wishes and bright hopes!\n\nYou have so much to offer, and the world is lucky to receive it.\n\nWith warmth",
        "Best Wishes!\n\nHere's to new beginnings, fresh opportunities, and all the wonderful things waiting just around the corner.\n\nWith encouragement",
        "Wishing you all good things!\n\nMay this new adventure be everything you hope for and more.\n\nWith warmth and love",
        "Best Wishes!\n\nYou have worked hard and you are ready. Go show the world what you are made of.\n\nWith pride",
        "All my best to you!\n\nWhatever the future holds, I have full faith that you will meet it with courage and grace.\n\nWith warm regards"
      ],

      halloween: [
        "Happy Halloween!\n\nHope your night is full of treats, fun, and just the right amount of spookiness.\n\nBoo!",
        "Happy Halloween!\n\nWishing you a fang-tastic evening filled with costumes, candy, and happy memories.\n\nWith spooky fun",
        "Hope your Halloween is wickedly wonderful!\n\nMay your bag be full of treats and your night be full of laughs.\n\nBoo!",
        "Happy Halloween!\n\nWhether you're trick-or-treating or staying in, I hope your night is full of smiles.\n\nWith spooky wishes",
        "Have a hauntingly good Halloween!\n\nWishing you a night filled with fun, friends, and plenty of candy.\n\nBoo!",
        "Happy Halloween!\n\nDon't be too spooked out there! Wishing you a creepy, fun, and sweet evening.\n\nWith all the candy",
        "Wishing you a ghoulishly great Halloween!\n\nMay your costume be epic and your candy haul be legendary.\n\nBoo!",
        "Happy Halloween!\n\nHope this spooky season brings you lots of laughs and a whole lot of treats.\n\nWith fun and fright",
        "Have a wickedly wonderful Halloween!\n\nWishing you a night full of magic, mystery, and your favorite candy.\n\nBoo!",
        "Happy Halloween!\n\nMay your jack-o-lanterns glow bright and your evening be filled with happy haunts.\n\nSpooky wishes"
      ],

      fathers_day: [
        "Happy Father's Day!\n\nThank you for your strength, your guidance, and the love you show every single day. You are amazing.\n\nWith love",
        "Happy Father's Day!\n\nYou have always been my anchor and my hero. I am so grateful to have you as my dad.\n\nWith all my love",
        "To the best dad in the world,\n\nThank you for everything you have done and everything you continue to be. Happy Father's Day!\n\nWith love",
        "Happy Father's Day!\n\nYour love and wisdom have shaped me into who I am today. I could not be more grateful.\n\nWith admiration",
        "Dad,\n\nNo words can fully express how much you mean to me. Thank you for being you. Happy Father's Day!\n\nWith love always",
        "Happy Father's Day!\n\nYou have given me so much, but your presence has been the greatest gift of all.\n\nWith love",
        "To my wonderful dad,\n\nThank you for every lesson, every laugh, and every moment of love. Happy Father's Day!\n\nWith all my heart",
        "Happy Father's Day!\n\nYou lead by example every day and inspire everyone around you. We are so lucky to have you.\n\nWith love",
        "Dad,\n\nThank you for always showing up, always believing in me, and always being there. Happy Father's Day!\n\nWith love",
        "Happy Father's Day!\n\nYou make it all look easy, even when it isn't. Thank you for your quiet strength and endless love.\n\nWith gratitude"
      ],

      get_well: [
        "Get Well Soon!\n\nSending you healing thoughts and warm wishes. Hope you are feeling like yourself again very soon.\n\nWith care",
        "Wishing you a speedy recovery!\n\nTake all the rest you need and know that I am thinking of you and cheering you on.\n\nWith love",
        "Get Well Soon!\n\nIllness is just a temporary detour. You will be back to your wonderful self in no time.\n\nWith warm thoughts",
        "Sending healing thoughts your way!\n\nPlease rest, take care of yourself, and know that many people are rooting for your quick recovery.\n\nWith care",
        "Get Well Soon!\n\nI miss your energy and your smile. Wishing you a swift and smooth recovery.\n\nWith warmth",
        "Thinking of you and wishing you well.\n\nMay each day bring you more comfort, more strength, and more reasons to smile.\n\nGet well soon!",
        "Get Well Soon!\n\nRest up, eat well, and let everyone take care of you for once. You deserve it.\n\nWith love",
        "Sending you lots of love and good vibes.\n\nHope you feel a little better each day until you're completely back to your best.\n\nGet well soon!",
        "Get Well Soon!\n\nYou are stronger than you know, and this is just a bump in the road. Wishing you a fast recovery.\n\nWith care",
        "Wishing you comfort and healing.\n\nTake it one day at a time and know that brighter, healthier days are just around the corner.\n\nGet well soon!"
      ],

      apology: [
        "I'm Sorry.\n\nI deeply regret my actions and the hurt they caused. Please know that your feelings matter more than anything to me.\n\nWith sincerity",
        "I owe you an apology.\n\nWhat happened was not okay, and I take full responsibility. I am truly sorry and committed to doing better.\n\nWith remorse",
        "I'm Sorry.\n\nI have been thinking about what happened, and I feel terrible. I value you too much to let this go unaddressed.\n\nWith regret",
        "Please forgive me.\n\nI made a mistake and I own it completely. I am sorry for the pain I caused and I hope we can move forward.\n\nWith sincerity",
        "I'm Sorry.\n\nYou deserved better from me, and I let you down. I am genuinely sorry and will work hard to earn back your trust.\n\nWith humility",
        "I want to apologize from the heart.\n\nMy actions were wrong and I regret them deeply. I care about you and I am truly sorry.\n\nWith sincerity",
        "I'm Sorry.\n\nThis was my fault. I should have done better, and I am committed to being better going forward.\n\nWith deep regret",
        "Please accept my sincere apology.\n\nWhat happened was not a reflection of how much I value you. I am so sorry.\n\nWith remorse",
        "I'm Sorry.\n\nForgiveness is something I hope to earn with time and changed actions, not just words. I am truly sorry.\n\nWith sincerity",
        "I regret what happened.\n\nYou mean too much to me for things to stay this way. I am sorry, and I hope we can heal from this.\n\nWith love"
      ],

      employee_appreciation: [
        "Thank You!\n\nYour dedication, hard work, and positive attitude make a real difference every single day. We truly appreciate you.\n\nWith gratitude",
        "We appreciate you!\n\nYour contributions go above and beyond, and we never take that for granted. Thank you for all you do.\n\nWith thanks",
        "Thank you for everything you bring to this team.\n\nYour talent, effort, and commitment inspire everyone around you. You are valued beyond measure.\n\nWith appreciation",
        "We see you and we appreciate you.\n\nYour hard work does not go unnoticed. Thank you for showing up every day with excellence.\n\nWith gratitude",
        "You are a true asset to this team.\n\nThank you for your exceptional work and the passion you bring to everything you do.\n\nWith sincere thanks",
        "Thank you for making a difference.\n\nYour work ethic, creativity, and dedication set the bar high for everyone. We are grateful for you.\n\nWith appreciation",
        "We could not do it without you.\n\nThank you for your commitment, your reliability, and the energy you bring to our team every day.\n\nWith gratitude",
        "Your hard work has not gone unnoticed.\n\nWe are so grateful for your contributions and the dedication you show day in and day out.\n\nWith thanks",
        "Thank you for going above and beyond.\n\nEmployees like you are the reason this team excels. Your efforts are truly appreciated.\n\nWith admiration",
        "You make this workplace better every day.\n\nThank you for your talent, your heart, and all the ways you contribute to our shared success.\n\nWith appreciation"
      ],

      new_baby: [
        "Congratulations on your new arrival!\n\nWelcome to the world, little one. You are already so loved by so many.\n\nWith joy",
        "A new baby is such a beautiful blessing!\n\nCongratulations! Wishing your growing family all the happiness in the world.\n\nWith love",
        "Welcome to the world!\n\nCongratulations on your newest family member. May every moment be filled with wonder and love.\n\nWith warm wishes",
        "Congratulations!\n\nThere is nothing quite like a new baby to fill a home with pure joy. Wishing you all a wonderful journey.\n\nWith love",
        "Welcome, little one!\n\nYour arrival has made the world a sweeter place. Congratulations to the whole family.\n\nWith joy and love",
        "Congratulations on your beautiful new baby!\n\nMay every giggle, every milestone, and every sleepy snuggle be a treasure.\n\nWith warmth",
        "A brand new baby is such a miracle.\n\nCongratulations! Wishing you all the love, rest, and happiness you can handle.\n\nWith joy",
        "Welcome to parenthood!\n\nIt is the greatest adventure there is. Congratulations on your precious new addition.\n\nWith love",
        "Congratulations on your growing family!\n\nThis little one is so lucky to be loved by you. Wishing you all wonderful days ahead.\n\nWith warm wishes",
        "What a precious gift!\n\nCongratulations on your new baby. May your home be full of laughter, love, and lots of sweet moments.\n\nWith joy"
      ],

      graduation: [
        "Congratulations, Graduate!\n\nYour hard work and determination have brought you to this incredible moment. The future is bright!\n\nWith pride",
        "You did it!\n\nAll those late nights, early mornings, and hard work have finally paid off. We are so proud of you.\n\nWith admiration",
        "Happy Graduation!\n\nThis is just the beginning of an amazing journey. The best is yet to come.\n\nWith excitement",
        "Congratulations, Grad!\n\nYou have earned every bit of this achievement. Go out and change the world!\n\nWith love",
        "What an accomplishment!\n\nYour dedication and perseverance have brought you here. Celebrate this milestone fully.\n\nWith pride",
        "Happy Graduation!\n\nThe tassel was worth the hassle! Wishing you all the success and happiness ahead.\n\nCheers to you",
        "Congratulations!\n\nAs one chapter closes, a new adventure begins. We cannot wait to see where you go.\n\nWith love",
        "You are officially amazing!\n\nGraduation is proof that great things come from hard work and belief in yourself.\n\nWith admiration",
        "Happy Graduation Day!\n\nDream big, work hard, and never stop learning. The world is yours.\n\nWith warmth",
        "Congratulations, Graduate!\n\nToday you close one book and open another. May every chapter ahead be your best.\n\nWith love and pride"
      ],

      memorial_day: [
        "In Honor and Remembrance\n\nToday we remember those who gave everything for our freedom. Their sacrifice will never be forgotten.\n\nWith deepest gratitude",
        "Memorial Day\n\nWe pause to honor the brave men and women who made the ultimate sacrifice for our country.\n\nWith reverence",
        "Remembering Our Heroes\n\nTheir courage and selflessness gave us the freedom we cherish today. We will never forget.\n\nWith honor",
        "In Loving Memory\n\nToday we remember those who served and sacrificed. Their legacy lives on in our hearts.\n\nWith gratitude",
        "Memorial Day\n\nFreedom is not free. We honor those who paid the highest price so that we may live in liberty.\n\nWith respect",
        "Honoring Our Fallen\n\nTheir bravery, service, and sacrifice have shaped the nation we are today. We remember them always.\n\nWith deepest thanks",
        "Memorial Day\n\nA day to reflect, remember, and honor the heroes who gave their lives for our great nation.\n\nWith solemn gratitude",
        "In Remembrance\n\nWe honor the memory of those who served with courage, honor, and unwavering devotion to our country.\n\nWith love",
        "Memorial Day\n\nLet us never forget the cost of freedom. We honor every life given in service to our nation.\n\nWith reverence",
        "Land of the Free\n\nBecause of the brave. Today and every day, we remember and honor their sacrifice.\n\nWith eternal gratitude"
      ],

      blank: [
        "A Little Something for You\n\nSent with warm thoughts and a wish that today treats you well.\n\nWarmly",
        "Thinking of You\n\nNo special occasion needed. Just a reminder that you are appreciated more than you know.\n\nWith love",
        "Enjoy!\n\nSomething sweet, chosen with you in mind. Savor it slowly.\n\nBest wishes",
        "With Heartfelt Thanks\n\nFor everything you do, big and small. Please enjoy this small token of appreciation.\n\nGratefully",
        "Sending Smiles Your Way\n\nLife is sweeter when it is shared. Hope this brings a little joy to your day.\n\nWarm regards",
        "Just Because\n\nSome gifts do not need a reason. This one comes simply because you are wonderful.\n\nWith love",
        "With Our Compliments\n\nWishing you good company and good moments to enjoy this.\n\nCheers",
        "For You\n\nA small surprise to say you matter. Take a moment, treat yourself, and know you are thought of.\n\nFondly",
        "Warm Wishes\n\nMay your days be full of good things, and your table full of sweet ones.\n\nWith warmest regards",
        "Hello!\n\nJust a note, and a treat, to let you know you crossed my mind today. Hope it makes you smile.\n\nTake care"
      ],

      thanksgiving: [
        "Happy Thanksgiving\n\nGrateful for you today and every day. May your table be full and your heart even fuller.\n\nWith love",
        "Giving Thanks\n\nOf all the blessings this year, you are among the ones we count first. Wishing you a warm and joyful Thanksgiving.\n\nWith gratitude",
        "Happy Thanksgiving\n\nMay your day be filled with good food, good company, and moments worth remembering.\n\nWarmly",
        "Thankful for You\n\nThis season is a reminder of how lucky we are to have you in our lives. Enjoy every bite and every laugh.\n\nWith heartfelt thanks",
        "Happy Thanksgiving\n\nHere is to full plates, warm hearts, and the people who make it all worthwhile.\n\nWith love and gratitude",
        "Gather and Give Thanks\n\nWishing you a holiday wrapped in warmth, surrounded by the ones you love most.\n\nWarm wishes",
        "Happy Thanksgiving\n\nFrom our family to yours, thank you for being part of our year. May the season treat you kindly.\n\nWith appreciation",
        "Grateful Hearts\n\nSome things deserve more than a thank you. You are one of them. Have a beautiful Thanksgiving.\n\nWith love",
        "Happy Thanksgiving\n\nA little sweetness from the orchard to share around your table. Enjoy the day.\n\nWarmly",
        "So Much to Be Thankful For\n\nToday we pause to count our blessings, and you are near the top of the list.\n\nWith gratitude"
      ],

      new_year: [
        "Happy New Year\n\nHere is to fresh starts, bright days, and all the good things waiting ahead. Cheers to you!\n\nWith warm wishes",
        "Cheers to the New Year\n\nMay the coming year bring you health, happiness, and plenty of reasons to celebrate.\n\nWith love",
        "Happy New Year\n\nThank you for being part of the year that was. Wishing you an even better one ahead.\n\nWarmly",
        "New Year, New Memories\n\nMay every day of this new year be a little sweeter than the last.\n\nBest wishes",
        "Happy New Year\n\nOut with the old, in with the wonderful. Here is to everything you will accomplish this year.\n\nCheers",
        "Wishing You a Bright New Year\n\nMay it be filled with laughter, good company, and dreams that come true.\n\nWith love",
        "Happy New Year\n\nA fresh calendar, a clean slate, and a whole lot of possibility. Make it a great one.\n\nWarm regards",
        "Cheers!\n\nRaise a glass to new beginnings and the people who make them worth celebrating.\n\nWith warmest wishes",
        "Happy New Year\n\nGrateful for the year we shared and excited for the one ahead. Here is to you!\n\nWith appreciation",
        "Hello New Year\n\nMay it treat you gently, surprise you kindly, and bring you joy in every season.\n\nWarmly"
      ],

      july_4th: [
        "Happy 4th of July\n\nWishing you a day full of sunshine, sparklers, and good company. Enjoy the celebration!\n\nWarmly",
        "Happy Independence Day\n\nHere is to freedom, family, and fireworks. Have a safe and wonderful Fourth.\n\nWith warm wishes",
        "Happy 4th of July\n\nMay your day be as bright as the fireworks and as sweet as summer. Celebrate well.\n\nCheers",
        "Let Freedom Ring\n\nGrateful for this country and for people like you who make it home. Happy Fourth!\n\nWith love",
        "Happy 4th of July\n\nSending a little Texas sweetness to go with your cookout. Enjoy every bite and every burst of color.\n\nBest wishes",
        "Stars, Stripes, and Smiles\n\nWishing you a joyful Independence Day surrounded by the people you love.\n\nWarm regards",
        "Happy 4th of July\n\nFrom our family to yours, have a safe, happy, and delicious holiday.\n\nWith appreciation",
        "Land of the Free\n\nToday we celebrate what makes this country great, and you are part of that. Happy Fourth!\n\nWith gratitude",
        "Happy Independence Day\n\nMay your grill stay hot, your lemonade stay cold, and your fireworks light up the night.\n\nCheers",
        "Happy 4th of July\n\nHere is to summer evenings, big skies, and celebrating together.\n\nWith warm wishes"
      ],

      labor_day: [
        "Happy Labor Day\n\nThank you for all the hard work you put in, day after day. Enjoy a well-deserved break.\n\nWith appreciation",
        "Happy Labor Day\n\nYour effort and dedication do not go unnoticed. Today, rest, relax, and enjoy something sweet.\n\nWith gratitude",
        "Enjoy a Well-Deserved Break\n\nHere is to the work you do and the difference it makes. Happy Labor Day!\n\nWarmly",
        "Happy Labor Day\n\nWishing you a long weekend full of rest, good food, and good company.\n\nBest wishes",
        "Thank You for Your Hard Work\n\nEvery success is built on dedication like yours. Take today to celebrate it.\n\nWith appreciation",
        "Happy Labor Day\n\nCelebrating you and everything you bring to the table, this weekend and every day.\n\nWith thanks",
        "Happy Labor Day\n\nA little sweetness from the orchard to make your day off even better. You have earned it.\n\nWarm regards",
        "Here Is to Hard Work\n\nAnd to the people who make it look easy. Enjoy a restful Labor Day.\n\nWith gratitude",
        "Happy Labor Day\n\nMay your weekend be long, your worries be short, and your treats be plentiful.\n\nCheers",
        "Happy Labor Day\n\nThank you for your dedication all year long. Wishing you a relaxing holiday.\n\nWith appreciation"
      ]

    };

    this.init();
  }

  /**
   * Calendar date of a dated category in a given year, or null for an
   * evergreen category. Drives the picker's date-proximity ordering.
   */
  holidayDate(key, year) {
    switch (key) {
      case 'valentines_day':
        return new Date(year, 1, 14); // Feb 14

      case 'easter': {
        // Anonymous Gregorian algorithm
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31) - 1; // 0-indexed
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(year, month, day);
      }

      case 'mothers_day': {
        // 2nd Sunday in May
        const firstDayOfMay = new Date(year, 4, 1).getDay(); // 0 = Sun
        const firstSunday = firstDayOfMay === 0 ? 1 : 8 - firstDayOfMay;
        return new Date(year, 4, firstSunday + 7);
      }

      case 'fathers_day': {
        // 3rd Sunday in June
        const firstDayOfJune = new Date(year, 5, 1).getDay(); // 0 = Sun
        const firstSunday = firstDayOfJune === 0 ? 1 : 8 - firstDayOfJune;
        return new Date(year, 5, firstSunday + 14);
      }

      case 'halloween':
        return new Date(year, 9, 31); // Oct 31

      case 'memorial_day': {
        // Last Monday in May
        const lastDay = new Date(year, 4, 31); // May 31
        const dayOfWeek = lastDay.getDay(); // 0 = Sun
        const offset = dayOfWeek >= 1 ? dayOfWeek - 1 : 6;
        return new Date(year, 4, 31 - offset);
      }

      case 'christmas':
        return new Date(year, 11, 25); // Dec 25

      case 'thanksgiving': {
        // 4th Thursday in November
        const firstDayOfNov = new Date(year, 10, 1).getDay(); // 0 = Sun
        const firstThursday = firstDayOfNov <= 4 ? 5 - firstDayOfNov : 12 - firstDayOfNov;
        return new Date(year, 10, firstThursday + 21);
      }

      case 'new_year':
        return new Date(year, 0, 1); // Jan 1

      case 'july_4th':
        return new Date(year, 6, 4); // Jul 4

      case 'labor_day': {
        // 1st Monday in September
        const firstDayOfSep = new Date(year, 8, 1).getDay(); // 0 = Sun
        const firstMonday = firstDayOfSep <= 1 ? 2 - firstDayOfSep : 9 - firstDayOfSep;
        return new Date(year, 8, firstMonday);
      }

      default:
        return null; // Evergreen — no fixed annual date
    }
  }

  /**
   * Sort this.categories based on proximity to today's date.
   * Rules:
   *  1. Holidays within 1 month (0–30 days away) → first, ordered by nearest date
   *  2. Holidays passed within PASSED_GRACE_DAYS → second (recently passed)
   *  3. Evergreen categories (no fixed date) → ordered by general popularity
   *  4. Upcoming holidays beyond 1 month → ordered by next occurrence date
   *     (once a holiday has passed, its date rolls to next year)
   */
  sortCategoriesByDate() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Days a holiday keeps its spot near the top after its date. Was 7, which
    // left Labor Day at the top of the picker three days after the holiday;
    // the shop asked (Sep 2026) that a passed holiday move straight down to
    // its place in the calendar, so the day of the holiday is the last day
    // it shows first.
    const PASSED_GRACE_DAYS = 0;

    // --- 1. Resolve a holiday's calendar date for a given year ---
    const getHolidayDate = (key, year) => this.holidayDate(key, year);

    // --- 2. Popularity rank for evergreen (non-date) categories ---
    // Lower number = more popular = shown earlier
    const evergreenRank = {
      birthday:               1,
      thank_you:              2,
      anniversary:            3,
      sympathy:               4,
      get_well:               5,
      congratulations:        6,
      thinking_of_you:        7,
      new_baby:               8,
      employee_appreciation:  9,
      welcome:               10,
      best_wishes:           11,
      apology:               12,
      graduation:            13,
    };

    const MS_PER_DAY = 86_400_000;

    // --- 3. Resolve the effective "next occurrence" date for each holiday key ---
    // Once it is past the grace window, roll forward to next year.
    const resolveNextDate = (key) => {
      let date = getHolidayDate(key, today.getFullYear());
      if (!date) return null; // Evergreen

      const diffDays = Math.round((date - today) / MS_PER_DAY);

      if (diffDays < -PASSED_GRACE_DAYS) {
        // Passed → use next year's date
        date = getHolidayDate(key, today.getFullYear() + 1);
      }

      return date;
    };

    // --- 4. Classify each category into a sorting bucket ---
    // Buckets: 'imminent' | 'recent' | 'evergreen' | 'upcoming'
    const classified = this.categories.map(cat => {
      const nextDate = resolveNextDate(cat.key);

      if (!nextDate) {
        return { cat, bucket: 'evergreen', diffDays: 0, nextDate: null };
      }

      const diffDays = Math.round((nextDate - today) / MS_PER_DAY);

      let bucket;
      if (diffDays >= 0 && diffDays <= 30) {
        bucket = 'imminent';  // Within the next 30 days
      } else if (diffDays < 0 && diffDays >= -PASSED_GRACE_DAYS) {
        bucket = 'recent';    // Passed within the grace window
      } else {
        bucket = 'upcoming';  // More than 1 month away (or rolled to next year)
      }

      return { cat, bucket, diffDays, nextDate };
    });

    // --- 5. Sort within each bucket, then by bucket priority ---
    const bucketOrder = { imminent: 0, recent: 1, evergreen: 2, upcoming: 3 };

    classified.sort((a, b) => {
      // Primary sort: bucket order
      const bucketDiff = bucketOrder[a.bucket] - bucketOrder[b.bucket];
      if (bucketDiff !== 0) return bucketDiff;

      // Secondary sort: within each bucket
      switch (a.bucket) {
        case 'imminent':
          // Nearest upcoming date first (smallest positive diffDays)
          return a.diffDays - b.diffDays;

        case 'recent':
          // Most recently passed first (diffDays is negative; closest to 0 = most recent)
          return b.diffDays - a.diffDays;

        case 'evergreen':
          // By popularity rank (lower rank = shown first)
          return (evergreenRank[a.cat.key] ?? 99) - (evergreenRank[b.cat.key] ?? 99);

        case 'upcoming':
          // Earliest next occurrence first
          return a.nextDate - b.nextDate;

        default:
          return 0;
      }
    });

    // --- 6. Overwrite categories with sorted result ---
    this.categories = classified.map(({ cat }) => cat);

    // --- 7. Pinned categories (Blank / upload your own) stay first regardless ---
    const pinned = this.pinnedCategories || [];
    this.categories = [
      ...pinned.map(key => this.categories.find(c => c.key === key)).filter(Boolean),
      ...this.categories.filter(c => !pinned.includes(c.key))
    ];
  }

  async init() {
    const element = document.querySelector(`[data-card-id="${this.id}"]`);
    if (element) {
      this.aiConfig = {
        enabled: element.dataset.aiEnabled === 'true',
        endpoint: element.dataset.aiEndpoint || '',
        recaptchaKey: element.dataset.recaptchaKey || ''
      };
      this.uploadApiEndpoint = element?.dataset.uploadEndpoint || 'https://giftcard.millicanpecan.com/api/create_giftcard';
      // Lets a dev/test page serve the new-gift artwork from somewhere other
      // than the Shopify Files CDN. Absent on the storefront.
      if (element.dataset.newGiftCdnBase) {
        this.newGiftCdnBase = element.dataset.newGiftCdnBase;
      }
    }

    // Sort categories by proximity to today before rendering
    this.sortCategoriesByDate();

    await this.loadProductData();
    await this.loadNewGiftCards();
    this.cacheElements();
    this.bindEvents();
    // Defer rendering ~141 template thumbnails until the modal first opens —
    // keeps the product page light (was loading every overlay JPG eagerly).
    this._templatesRendered = false;
    this.initializeEditor()
  }

  async loadProductData() {
    try {
      const response = await fetch(`/products/${this.productHandle}.js`);
      this.productData = await response.json();

      const priceElement = document.getElementById(`cardPrice-${this.id}`);
      if (priceElement && this.productData) {
        const price = (this.productData.price / 100).toFixed(2);
        priceElement.textContent = `$${price}`;
      }
      if (this.cardOptionImage && this.productData.featured_image) {
        this.cardOptionImage.src = this.productData.featured_image;
      }
    } catch (error) {
      console.error('Failed to load product:', error);
    }
  }

  /**
   * URL of a theme asset sitting next to this script.
   *
   * Theme assets are served from a versioned directory (/cdn/shop/t/<n>/assets/)
   * and that number changes every time the theme is duplicated or republished,
   * so it cannot be hard-coded. Deriving it from this file's own script tag
   * keeps it correct for whichever theme is actually running.
   */
  assetUrl(filename) {
    const tag = document.querySelector('script[src*="greeting-card-customizer.js"]');
    if (tag && tag.src) {
      // Carry the script's own "?v=..." stamp over to the sibling asset. The
      // CDN caches theme assets aggressively, and without a version the
      // catalogue kept serving its old copy long after a theme push; the JS
      // and the catalogue are pushed together, so its stamp is a fresh key.
      const [base, query] = tag.src.split('?');
      const url = base.replace(/[^/]+$/, '') + filename;
      return query ? `${url}?${query}` : url;
    }
    return `/cdn/shop/assets/${filename}`;
  }

  async loadNewGiftCards() {
    // The bare /cdn/shop/assets/ path 404s on the storefront; it is kept as a
    // fallback only in case the script tag cannot be located.
    const candidates = [this.assetUrl('new-gift.json'), '/cdn/shop/assets/new-gift.json'];
    let data = null;
    let lastError = null;

    for (const assetPath of candidates) {
      try {
        const response = await fetch(assetPath);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        data = await response.json();
        break;
      } catch (error) {
        lastError = error;
      }
    }

    if (data) {
      const cards = Array.isArray(data) ? data : (data.cards || []);
      const existingIds = new Set(this.templates.map(t => t.id));
      for (const card of cards) {
        if (existingIds.has(card.id)) {
          console.warn(`new-gift.json id "${card.id}" collides with a legacy template; skipping.`);
          continue;
        }
        this.templates.push(this.normalizeNewGiftCard(card));
      }
    } else {
      console.warn('Failed to load new-gift.json; proceeding with legacy templates only.', lastError);
    }
    // If the user opened the modal before this fetch finished, the picker was
    // rendered with only the legacy 41 templates. Re-render now so the new
    // entries show up without a page reload.
    if (this._templatesRendered && this.templatesGrid) {
      this.renderTemplates();
    }
  }

  normalizeNewGiftCard(card) {
    const flatFile = (card.file || '').split('/').pop();
    // A slot that does not intersect the canvas can never show a photo; treat
    // the card as art-only rather than advertising a photo that never appears.
    let hasPhoto = !!card.hasPhoto;
    if (hasPhoto && card.photoSlot && card.canvas) {
      const s = card.photoSlot;
      const left = s.center.x - s.size.width / 2;
      const top = s.center.y - s.size.height / 2;
      const inside = left < card.canvas.width && top < card.canvas.height &&
        left + s.size.width > 0 && top + s.size.height > 0;
      if (!inside) {
        console.warn(`new-gift.json card "${card.id}" declares a photo slot outside its canvas; treating as no-photo.`);
        hasPhoto = false;
      }
    }
    return {
      id: card.id,
      name: this.deriveTemplateName(card),
      overlayImage: this.newGiftCdnBase + flatFile,
      canCustom: hasPhoto,
      type: card.category,
      orientation: card.orientation,
      source: 'new-gift',
      hasPhoto,
      photoSlot: hasPhoto ? (card.photoSlot || null) : null,
      bakedText: card.bakedText || null,
      canvas: card.canvas || null
    };
  }

  deriveTemplateName(card) {
    if (card.bakedText) return card.bakedText;
    const trimmed = (card.id || '').replace(/^[a-z]+\d+-/, '');
    return trimmed.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  drawHeartPath(ctx, cx, cy, w, h) {
    const top = cy - h / 2;
    const bottom = cy + h / 2;
    const left = cx - w / 2;
    const right = cx + w / 2;
    const lobeY = top + h * 0.3;
    ctx.moveTo(cx, top + h * 0.25);
    ctx.bezierCurveTo(cx, top, left, top, left, lobeY);
    ctx.bezierCurveTo(left, cy, cx, cy + h * 0.25, cx, bottom);
    ctx.bezierCurveTo(cx, cy + h * 0.25, right, cy, right, lobeY);
    ctx.bezierCurveTo(right, top, cx, top, cx, top + h * 0.25);
  }

  // Thumbnail URL for the picker grid. New-gift overlays are full-resolution
  // JPGs (~1MB each) on Shopify's CDN; appending ?width=400 gets a small
  // resized variant. Legacy assets keep their existing URL untouched.
  getThumbnailUrl(template) {
    if (template.source === 'new-gift' && template.overlayImage) {
      const sep = template.overlayImage.includes('?') ? '&' : '?';
      return `${template.overlayImage}${sep}width=400`;
    }
    return template.overlayImage;
  }

  clipToPhotoSlot(ctx, slot, cx, cy, sw, sh) {
    ctx.beginPath();
    if (slot.rotation) {
      ctx.translate(cx, cy);
      ctx.rotate(slot.rotation * Math.PI / 180);
      ctx.translate(-cx, -cy);
    }
    switch (slot.shape) {
      case 'rectangle':
        ctx.rect(cx - sw / 2, cy - sh / 2, sw, sh);
        break;
      case 'circle':
      case 'oval':
        ctx.ellipse(cx, cy, sw / 2, sh / 2, 0, 0, 2 * Math.PI);
        break;
      case 'heart':
        this.drawHeartPath(ctx, cx, cy, sw, sh);
        break;
      default:
        ctx.rect(cx - sw / 2, cy - sh / 2, sw, sh);
    }
    ctx.clip();
  }

  cacheElements() {
    this.cardOptionTrigger = document.getElementById(`cardOptionTrigger-${this.id}`);
    this.cardOptionImage = document.getElementById(`cardOptionImage-${this.id}`);
    this.chooseCardBtn = document.getElementById(`chooseCardBtn-${this.id}`);
    this.modal = document.getElementById(`cardCustomizerModal-${this.id}`);
    this.templatesGrid = document.getElementById(`templatesGrid-${this.id}`);
    this.categoryFilters = document.getElementById(`categoryFilters-${this.id}`);
    this.progressBar = document.getElementById(`progressBar-${this.id}`);
    this.activeFilter = 'all'; // Track active filter

    // Step 2: Photo editing elements (Cardisle-style)
    this.photoInitialState = document.getElementById(`photoInitialState-${this.id}`);
    this.photoEditState = document.getElementById(`photoEditState-${this.id}`);
    this.addPhotoBtn = document.getElementById(`addPhotoBtn-${this.id}`);
    this.addPhotoBtnOverlay = document.getElementById(`addPhotoBtnOverlay-${this.id}`);
    this.photoInput = document.getElementById(`photoInput-${this.id}`);
    this.selectedTemplatePreview = document.getElementById(`selectedTemplatePreview-${this.id}`);
    this.cardCanvas = document.getElementById(`cardCanvas-${this.id}`);
    this.cardDisplayInner = document.getElementById(`cardDisplayInner-${this.id}`);
    this.photoPlaceholder = document.getElementById(`photoPlaceholder-${this.id}`);
    this.photoInstructions = document.getElementById(`photoInstructions-${this.id}`);
    this.btnGotIt = document.getElementById(`btnGotIt-${this.id}`);
    this.photoDoneBtn = document.getElementById(`photoDoneBtn-${this.id}`);
    this.zoomSlider = document.getElementById(`zoomSlider-${this.id}`);
    this.zoomSliderMobile = document.getElementById(`zoomSliderMobile-${this.id}`);
    this.stepTitle = document.getElementById(`stepTitle-${this.id}`);
    this.stepHelp = document.getElementById(`stepHelp-${this.id}`);

    // Step 2: saved image (logo) reuse
    this.savedImageBlock = document.getElementById(`savedImageBlock-${this.id}`);
    this.savedImageThumb = document.getElementById(`savedImageThumb-${this.id}`);
    this.useSavedImageBtn = document.getElementById(`useSavedImageBtn-${this.id}`);
    this.forgetSavedImageBtn = document.getElementById(`forgetSavedImageBtn-${this.id}`);
    this.saveImageToggle = document.getElementById(`saveImageToggle-${this.id}`);
    this.saveImageLabel = document.getElementById(`saveImageLabel-${this.id}`);
    this.savedImageNote = document.getElementById(`savedImageNote-${this.id}`);
    this.blankHint = document.getElementById(`blankHint-${this.id}`);
    this.fitToggle = document.getElementById(`fitToggle-${this.id}`);

    // Step 2: crop overlay
    this.cropOverlay = document.getElementById(`cropOverlay-${this.id}`);
    this.cropStage = document.getElementById(`cropStage-${this.id}`);
    this.cropCanvas = document.getElementById(`cropCanvas-${this.id}`);
    this.cropBox = document.getElementById(`cropBox-${this.id}`);
    this.cropQualityNote = document.getElementById(`cropQuality-${this.id}`);

    // Step 3: Position sliders (mobile)
    this.posXSlider = document.getElementById(`posXSlider-${this.id}`);
    this.posYSlider = document.getElementById(`posYSlider-${this.id}`);
    this.posXValue = document.getElementById(`posXValue-${this.id}`);
    this.posYValue = document.getElementById(`posYValue-${this.id}`);

    // Step 3: Message editor elements (draggable text box)
    this.messageCardCanvas = document.getElementById(`messageCardCanvas-${this.id}`);
    this.draggableTextBox = document.getElementById(`draggableTextBox-${this.id}`);
    this.messageEditor = document.getElementById(`cardMessageEditor-${this.id}`);
    this.fontSelector = document.getElementById(`fontSelector-${this.id}`);
    this.fontSizeSelector = document.getElementById(`fontSizeSelector-${this.id}`);
    this.fontSizeSlider = document.getElementById(`fontSizeSlider-${this.id}`);
    this.drawerSizeValue = document.getElementById(`drawerSizeValue-${this.id}`);
    this.textColorPicker = document.getElementById(`textColorPicker-${this.id}`);

    // Step 4: Final preview elements (flip card)
    this.finalPreviewCanvas = document.getElementById(`finalPreviewCanvas-${this.id}`);
    this.flipCard = document.getElementById(`flipCard-${this.id}`);
    this.flipCardContainer = document.getElementById(`flipCardContainer-${this.id}`);
    this.flipCardMessage = document.getElementById(`flipCardMessage-${this.id}`);
    this.btnShowFront = document.getElementById(`btnShowFront-${this.id}`);
    this.btnShowBack = document.getElementById(`btnShowBack-${this.id}`);
    this.summaryTemplate = document.getElementById(`summaryTemplate-${this.id}`);
    this.summaryPhoto = document.getElementById(`summaryPhoto-${this.id}`);
    this.summaryPrice = document.getElementById(`summaryPrice-${this.id}`);
    this.messagePreview = document.getElementById(`messagePreview-${this.id}`);
    this.messagePreviewText = document.getElementById(`messagePreviewText-${this.id}`);
    this.summaryMessage = document.getElementById(`summaryMessage-${this.id}`);

    // AI Assistant elements
    this.aiOpenBtn = document.getElementById(`openAIModal-${this.id}`);
    this.aiModal = document.getElementById(`aiModal-${this.id}`);
    this.aiCloseBtn = document.getElementById(`closeAIModal-${this.id}`);
    this.aiPillsContainer = document.getElementById(`aiPills-${this.id}`);
    this.aiRewriteBtn = document.getElementById(`aiRewriteBtn-${this.id}`);
  }

  bindEvents() {
    // Other scripts re-render the product form area a few seconds after load,
    // which silently destroys listeners bound directly to the trigger box.
    // Delegate from document so opening the modal survives that re-render.
    document.addEventListener('click', (e) => {
      if (e.target instanceof Element &&
          e.target.closest(`#cardOptionTrigger-${this.id}, #chooseCardBtn-${this.id}`)) {
        this.openModal();
      }
    });
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') &&
          e.target instanceof Element &&
          e.target.closest(`#cardOptionTrigger-${this.id}`)) {
        e.preventDefault();
        this.openModal();
      }
    });

    // Cart page: clicking a greeting card line's image or its "Edit card"
    // button reopens the customizer prefilled from the line's _card-state.
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const editEl = e.target.closest('[data-edit-card-state]');
      if (editEl) {
        e.preventDefault();
        this.openModalForEdit(editEl.dataset.editCardState, editEl.dataset.lineKey);
      }
    });

    document.querySelector(`[data-close-modal="${this.id}"]`).addEventListener('click', () => this.closeModal());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    document.querySelector(`[data-prev-step="${this.id}"]`).addEventListener('click', () => this.previousStep());
    document.querySelector(`[data-next-step="${this.id}"]`).addEventListener('click', () => this.nextStep());
    document.querySelector(`[data-add-to-cart="${this.id}"]`).addEventListener('click', () => this.addToCart());

    // Mobile Step 3 close button
    const mobileStep3Close = document.getElementById(`mobileStep3Close-${this.id}`);
    if (mobileStep3Close) {
      mobileStep3Close.addEventListener('click', () => this.previousStep());
    }

    // Recalculate scaled font size on resize (when on Step 3)
    window.addEventListener('resize', () => {
      if (this.currentStep === 3) {
        this.updateScaledFontSize();
      }
    });

    // Photo upload buttons (both main button and overlay button)
    if (this.addPhotoBtn) {
      this.addPhotoBtn.addEventListener('click', () => this.photoInput.click());
    }
    if (this.addPhotoBtnOverlay) {
      this.addPhotoBtnOverlay.addEventListener('click', () => this.photoInput.click());
    }

    if (this.photoInput) {
      this.photoInput.addEventListener('change', (e) => this.handlePhotoUpload(e));
    }

    // Saved image (logo) reuse
    if (this.useSavedImageBtn) {
      this.useSavedImageBtn.addEventListener('click', () => this.useSavedImage());
    }
    if (this.forgetSavedImageBtn) {
      this.forgetSavedImageBtn.addEventListener('click', () => this.forgetSavedImage());
    }
    if (this.saveImageToggle) {
      this.saveImageToggle.addEventListener('change', () => {
        if (this.saveImageToggle.checked) {
          this.saveCurrentImage();
        } else if (this._savedThisSession) {
          // Unticking undoes a save made just now; an image saved on an
          // earlier visit is only removed via the explicit "Remove" control.
          this.forgetSavedImage({ announce: true });
        }
      });
    }
    if (this.fitToggle) {
      this.fitToggle.querySelectorAll('[data-fit-mode]').forEach(btn => {
        btn.addEventListener('click', () => this.setBlankFitMode(btn.dataset.fitMode));
      });
    }

    // Photo instructions "Got It" button
    if (this.btnGotIt) {
      this.btnGotIt.addEventListener('click', () => this.hidePhotoInstructions());
    }

    // Photo "Done" button
    if (this.photoDoneBtn) {
      this.photoDoneBtn.addEventListener('click', () => this.finishPhotoEditing());
    }

    // Remove and rotate buttons (multiple instances for mobile/desktop)
    const removePhotoBtns = document.querySelectorAll(`[data-remove-photo="${this.id}"]`);
    removePhotoBtns.forEach(btn => {
      btn.addEventListener('click', () => this.removePhoto());
    });

    const rotateBtns = document.querySelectorAll(`[data-rotate-photo="${this.id}"]`);
    rotateBtns.forEach(btn => {
      btn.addEventListener('click', () => this.rotatePhoto());
    });

    this.bindCropperEvents();

    const resetBtn = document.querySelector(`[data-reset-position="${this.id}"]`);
    if (resetBtn) resetBtn.addEventListener('click', () => this.resetPosition());

    if (this.cardCanvas) {
      this.cardCanvas.addEventListener('mousedown', (e) => this.startDrag(e));
      this.cardCanvas.addEventListener('touchstart', (e) => this.startDrag(e));

      document.addEventListener('mousemove', (e) => this.drag(e));
      document.addEventListener('touchmove', (e) => this.drag(e));

      document.addEventListener('mouseup', () => this.endDrag());
      document.addEventListener('touchend', () => this.endDrag());
    }

    if (this.zoomSlider) {
      this.zoomSlider.addEventListener('input', (e) => {
        // New slider uses 0.5-2 range, convert to percentage (50-200)
        const sliderValue = parseFloat(e.target.value);
        this.zoom = Math.round(sliderValue * 100);
        this.renderPhotoPreview();
        // Sync mobile slider
        if (this.zoomSliderMobile) this.zoomSliderMobile.value = e.target.value;
      });
    }

    // Mobile zoom slider - mirrors desktop behavior
    if (this.zoomSliderMobile) {
      this.zoomSliderMobile.addEventListener('input', (e) => {
        const sliderValue = parseFloat(e.target.value);
        this.zoom = Math.round(sliderValue * 100);
        this.renderPhotoPreview();
        // Sync desktop slider
        if (this.zoomSlider) this.zoomSlider.value = e.target.value;
      });
    }

    // Mobile position sliders for text box
    if (this.posXSlider) {
      this.posXSlider.addEventListener('input', (e) => {
        const val = parseInt(e.target.value);
        this.textBoxPosition.x = val;
        if (this.posXValue) this.posXValue.textContent = val + '%';
        this.updateTextBoxFromSliders();
      });
    }

    if (this.posYSlider) {
      this.posYSlider.addEventListener('input', (e) => {
        const val = parseInt(e.target.value);
        this.textBoxPosition.y = val;
        if (this.posYValue) this.posYValue.textContent = val + '%';
        this.updateTextBoxFromSliders();
      });
    }

    // Step 3: Message Editor
    if (this.messageEditor) {
      this.messageEditor.addEventListener('input', () => {
        this.customMessage = this.messageEditor.value;
      });

      // Prevent pasting with rich formatting
      this.messageEditor.addEventListener('paste', (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        const start = this.messageEditor.selectionStart;
        const end = this.messageEditor.selectionEnd;
        const currentValue = this.messageEditor.value;

        this.messageEditor.value = currentValue.substring(0, start) + text + currentValue.substring(end);
        this.messageEditor.selectionStart = this.messageEditor.selectionEnd = start + text.length;
        this.customMessage = this.messageEditor.value;
      });
    }

    if (this.fontSelector) {
      this.fontSelector.addEventListener('change', () => {
        this.messageEditor.style.fontFamily = this.fontSelector.value;
      });
    }

    if (this.fontSizeSelector) {
      this.fontSizeSelector.addEventListener('change', () => {
        this.updateScaledFontSize();
      });
    }

    if (this.textColorPicker) {
      this.textColorPicker.addEventListener('change', () => {
        this.messageEditor.style.color = this.textColorPicker.value;
      });
    }

    document.querySelectorAll('[data-align]').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('[data-align]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const align = btn.dataset.align;
        this.messageEditor.style.textAlign = align;
      });
    });

    // Step 3: Drawer-based formatting controls
    this.initFormatDrawers();

    // Step 3: Draggable text box
    this.initDraggableTextBox();

    // Step 4: Flip card
    this.initFlipCard();

    if (this.aiOpenBtn) {
      this.aiOpenBtn.addEventListener('click', () => this.openAIModal());
    }
    if (this.aiCloseBtn) {
      this.aiCloseBtn.addEventListener('click', () => this.closeAIModal());
    }
    if (this.aiModal) {
      this.aiModal.addEventListener('click', (e) => {
        if (e.target === this.aiModal) this.closeAIModal();
      });
    }
    if (this.aiPillsContainer) {
      this.aiPillsContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('card-ai-pill')) {
          this.toggleAIPill(e.target);
        }
      });
    }
    if (this.aiRewriteBtn) {
      this.aiRewriteBtn.addEventListener('click', () => this.rewriteMessage());
    }
  }

  /**
   * Initialize drawer-based formatting controls for Step 3
   */
  initFormatDrawers() {
    const resizeBtn = document.getElementById(`btnResize-${this.id}`);
    const fontBtn = document.getElementById(`btnFont-${this.id}`);
    const sizeBtn = document.getElementById(`btnSize-${this.id}`);
    const colorBtn = document.getElementById(`btnColor-${this.id}`);
    const alignBtn = document.getElementById(`btnAlign-${this.id}`);
    const emojiBtn = document.getElementById(`btnEmoji-${this.id}`);

    const resizeDrawer = document.getElementById(`resizeDrawer-${this.id}`);
    const fontDrawer = document.getElementById(`fontDrawer-${this.id}`);
    const sizeDrawer = document.getElementById(`sizeDrawer-${this.id}`);
    const colorDrawer = document.getElementById(`colorDrawer-${this.id}`);
    const alignDrawer = document.getElementById(`alignDrawer-${this.id}`);
    const emojiDrawer = document.getElementById(`emojiDrawer-${this.id}`);

    const colorPreview = document.getElementById(`colorPreview-${this.id}`);
    const fontSizeLabel = document.getElementById(`fontSizeLabel-${this.id}`);

    // Toggle drawer visibility
    const toggleDrawer = (drawer) => {
      const allDrawers = [resizeDrawer, fontDrawer, sizeDrawer, colorDrawer, alignDrawer, emojiDrawer];
      allDrawers.forEach(d => {
        if (d && d !== drawer) d.classList.remove('active');
      });
      if (drawer) drawer.classList.toggle('active');
    };

    // Resize button click
    if (resizeBtn && resizeDrawer) {
      resizeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(resizeDrawer);
      });
    }

    // Resize sliders
    const widthSlider = document.getElementById(`widthSlider-${this.id}`);
    const heightSlider = document.getElementById(`heightSlider-${this.id}`);
    const widthValue = document.getElementById(`widthValue-${this.id}`);
    const heightValue = document.getElementById(`heightValue-${this.id}`);

    if (widthSlider) {
      widthSlider.addEventListener('input', (e) => {
        const width = parseInt(e.target.value, 10);
        this.textBoxSize.width = width;
        this.updateTextBoxSize();
        if (widthValue) widthValue.textContent = `${width}%`;
      });
    }

    if (heightSlider) {
      heightSlider.addEventListener('input', (e) => {
        const height = parseInt(e.target.value, 10);
        this.textBoxSize.height = height;
        this.updateTextBoxSize();
        if (heightValue) heightValue.textContent = `${height}%`;
      });
    }

    // Font button click
    if (fontBtn && fontDrawer) {
      fontBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(fontDrawer);
      });
    }

    // Size button click
    if (sizeBtn && sizeDrawer) {
      sizeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(sizeDrawer);
      });
    }

    // Color button click
    if (colorBtn && colorDrawer) {
      colorBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(colorDrawer);
      });
    }

    // Align button click
    if (alignBtn && alignDrawer) {
      alignBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(alignDrawer);
      });
    }

    // Emoji button click
    if (emojiBtn && emojiDrawer) {
      emojiBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(emojiDrawer);
      });
    }

    // Mobile format buttons - connect to same drawers
    const resizeBtnMobile = document.getElementById(`btnResizeMobile-${this.id}`);
    const fontBtnMobile = document.getElementById(`btnFontMobile-${this.id}`);
    const sizeBtnMobile = document.getElementById(`btnSizeMobile-${this.id}`);
    const colorBtnMobile = document.getElementById(`btnColorMobile-${this.id}`);
    const alignBtnMobile = document.getElementById(`btnAlignMobile-${this.id}`);
    const emojiBtnMobile = document.getElementById(`btnEmojiMobile-${this.id}`);
    const doneBtnMobile = document.getElementById(`btnMessageDoneMobile-${this.id}`);
    const colorPreviewMobile = document.getElementById(`colorPreviewMobile-${this.id}`);
    const fontSizeLabelMobile = document.getElementById(`fontSizeLabelMobile-${this.id}`);

    if (resizeBtnMobile && resizeDrawer) {
      resizeBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(resizeDrawer);
      });
    }

    if (fontBtnMobile && fontDrawer) {
      fontBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(fontDrawer);
      });
    }

    if (sizeBtnMobile && sizeDrawer) {
      sizeBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(sizeDrawer);
      });
    }

    if (colorBtnMobile && colorDrawer) {
      colorBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(colorDrawer);
      });
    }

    if (alignBtnMobile && alignDrawer) {
      alignBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(alignDrawer);
      });
    }

    if (emojiBtnMobile && emojiDrawer) {
      emojiBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(emojiDrawer);
      });
    }

    // Mobile Done button - advance to next step
    if (doneBtnMobile) {
      doneBtnMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDrawer(null); // Close any open drawer
        this.nextStep();
      });
    }

    // Store references for updating mobile UI
    this.colorPreviewMobile = colorPreviewMobile;
    this.fontSizeLabelMobile = fontSizeLabelMobile;

    // Font item clicks
    if (fontDrawer) {
      fontDrawer.querySelectorAll('.drawer-font-item').forEach(item => {
        item.addEventListener('click', () => {
          const font = item.dataset.font;
          if (this.messageEditor) {
            this.messageEditor.style.fontFamily = font;
          }
          if (this.fontSelector) {
            this.fontSelector.value = font;
          }
          fontDrawer.querySelectorAll('.drawer-font-item').forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          toggleDrawer(null);
        });
      });
    }

    // Font size slider
    if (this.fontSizeSlider) {
      this.fontSizeSlider.addEventListener('input', (e) => {
        const size = e.target.value;
        if (this.fontSizeSelector) {
          this.fontSizeSelector.value = size;
        }
        if (fontSizeLabel) {
          fontSizeLabel.textContent = size + 'pt';
        }
        if (fontSizeLabelMobile) {
          fontSizeLabelMobile.textContent = size + 'pt';
        }
        if (this.drawerSizeValue) {
          this.drawerSizeValue.textContent = size + 'pt';
        }
        this.updateScaledFontSize();
      });
    }

    // Color item clicks
    if (colorDrawer) {
      colorDrawer.querySelectorAll('.drawer-color-item').forEach(item => {
        item.addEventListener('click', () => {
          const color = item.dataset.color;
          if (this.messageEditor) {
            this.messageEditor.style.color = color;
          }
          if (this.textColorPicker) {
            this.textColorPicker.value = color;
          }
          if (colorPreview) {
            colorPreview.style.backgroundColor = color;
          }
          // Update mobile color preview too
          if (colorPreviewMobile) {
            colorPreviewMobile.style.backgroundColor = color;
          }
          colorDrawer.querySelectorAll('.drawer-color-item').forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          toggleDrawer(null);
        });
      });
    }

    // Align item clicks
    if (alignDrawer) {
      alignDrawer.querySelectorAll('.drawer-align-item').forEach(item => {
        item.addEventListener('click', () => {
          const align = item.dataset.align;
          if (this.messageEditor) {
            this.messageEditor.style.textAlign = align;
          }
          alignDrawer.querySelectorAll('.drawer-align-item').forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          toggleDrawer(null);
        });
      });
    }

    // Emoji item clicks
    if (emojiDrawer) {
      emojiDrawer.querySelectorAll('.drawer-emoji-item').forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const emoji = item.dataset.emoji;
          if (this.messageEditor && emoji) {
            // Store current selection before focus changes it
            const start = this.messageEditor.selectionStart || 0;
            const end = this.messageEditor.selectionEnd || 0;
            const text = this.messageEditor.value || '';

            // Insert emoji at cursor position
            this.messageEditor.value = text.substring(0, start) + emoji + text.substring(end);

            // Update customMessage to keep state in sync
            this.customMessage = this.messageEditor.value;

            // Move cursor after the inserted emoji
            const newPosition = start + emoji.length;
            this.messageEditor.setSelectionRange(newPosition, newPosition);
            this.messageEditor.focus();
          }
          toggleDrawer(null);
        });
      });
    }

    // Close drawers when clicking outside (scoped to this modal instance)
    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        const isDrawerClick = e.target.closest('.format-drawer') ||
          e.target.closest('.btn-format') ||
          e.target.closest('.btn-format-mobile') ||
          e.target.closest('.format-buttons-row') ||
          e.target.closest('.message-controls-mobile');
        if (!isDrawerClick) {
          [resizeDrawer, fontDrawer, sizeDrawer, colorDrawer, alignDrawer, emojiDrawer].forEach(d => {
            if (d) d.classList.remove('active');
          });
        }
      });
    }

    // Also close drawers when clicking on the step 3 text area or backdrop
    document.addEventListener('click', (e) => {
      // Only handle if we're on step 3 and on mobile
      if (this.currentStep !== 3 || window.innerWidth > 768) return;

      const isDrawerClick = e.target.closest('.format-drawer') ||
        e.target.closest('.btn-format-mobile') ||
        e.target.closest('.message-controls-mobile');
      if (!isDrawerClick) {
        [resizeDrawer, fontDrawer, sizeDrawer, colorDrawer, alignDrawer, emojiDrawer].forEach(d => {
          if (d) d.classList.remove('active');
        });
      }
    });

    // Drawer close buttons (mobile bottom sheets)
    const allDrawers = [resizeDrawer, fontDrawer, sizeDrawer, colorDrawer, alignDrawer, emojiDrawer];
    allDrawers.forEach(drawer => {
      if (drawer) {
        const closeBtn = drawer.querySelector('.drawer-close-btn');
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            drawer.classList.remove('active');
          });
        }
      }
    });
  }

  /**
   * Initialize flip card functionality for Step 4 preview
   */
  initFlipCard() {
    if (!this.flipCard || !this.flipCardContainer) return;

    // Click on card to flip
    this.flipCardContainer.addEventListener('click', () => {
      this.flipCard.classList.toggle('flipped');
      this.updateFlipButtons();
    });

    // Front button click
    if (this.btnShowFront) {
      this.btnShowFront.addEventListener('click', (e) => {
        e.stopPropagation();
        this.flipCard.classList.remove('flipped');
        this.updateFlipButtons();
      });
    }

    // Back button click
    if (this.btnShowBack) {
      this.btnShowBack.addEventListener('click', (e) => {
        e.stopPropagation();
        this.flipCard.classList.add('flipped');
        this.updateFlipButtons();
      });
    }
  }

  /**
   * Update flip toggle button active states
   */
  updateFlipButtons() {
    const isFlipped = this.flipCard.classList.contains('flipped');

    if (this.btnShowFront) {
      this.btnShowFront.classList.toggle('active', !isFlipped);
    }
    if (this.btnShowBack) {
      this.btnShowBack.classList.toggle('active', isFlipped);
    }
  }

  /**
   * Scale font size in the message textarea to match print proportions.
   * The print canvas is 612x396 at 72 DPI (8.5"x5.5" landscape).
   * CSS pt uses 96/72 px conversion, so: scaledPx = ptSize * (4/3) * (canvasWidth / printWidth)
   */
  updateScaledFontSize() {
    if (!this.messageEditor || !this.messageCardCanvas) return;

    const fontSizePt = parseInt(this.fontSizeSelector?.value || '18', 10);
    const canvasWidth = this.messageCardCanvas.offsetWidth;
    if (canvasWidth <= 0) return;

    const orientation = this.selectedTemplate?.orientation || 'landscape';
    const printWidth = orientation === 'landscape' ? 612 : 396;

    const scaledPx = fontSizePt * (4 / 3) * (canvasWidth / printWidth);
    this.messageEditor.style.fontSize = scaledPx + 'px';
  }

  /**
   * Update the flip card message content with styled text
   */
  updateFlipCardMessage() {
    if (!this.flipCardMessage || !this.messageEditor) return;

    const messageText = this.messageEditor.value.trim();

    if (!messageText) {
      this.flipCardMessage.innerHTML = '<p style="color: #999; font-style: italic;">No message added</p>';
      this.flipCardMessage.style.left = '50%';
      this.flipCardMessage.style.top = '50%';
      this.flipCardMessage.style.transform = 'translate(-50%, -50%)';
      this.flipCardMessage.style.width = '80%';
      this.flipCardMessage.style.height = 'auto';
      return;
    }

    // Get styling from editor
    const font = this.fontSelector?.value || 'Arial';
    const fontSize = this.fontSizeSelector?.value || '20';
    const color = this.textColorPicker?.value || '#000000';
    const align = this.messageEditor.style.textAlign || 'center';

    // Set as plain text: the container is white-space: pre-wrap, so the
    // customer's newlines and blank lines render exactly as typed, in every
    // engine. The old \n-to-<br> conversion depended on how a browser lays
    // out <br> elements directly inside a display:flex container, which is
    // not interoperable - WebKit drops them, so on Safari the blank lines
    // between paragraphs vanished on the Preview step only.
    this.flipCardMessage.textContent = messageText;
    this.flipCardMessage.style.fontFamily = font;

    // Scale font size proportionally to the flip card width (matches print canvas)
    const flipCardWidth = this.flipCard ? this.flipCard.offsetWidth : 0;
    const orientation = this.selectedTemplate?.orientation || 'landscape';
    const printWidth = orientation === 'landscape' ? 612 : 396;
    if (flipCardWidth > 0) {
      const scaledPx = parseInt(fontSize, 10) * (4 / 3) * (flipCardWidth / printWidth);
      this.flipCardMessage.style.fontSize = scaledPx + 'px';
    } else {
      this.flipCardMessage.style.fontSize = fontSize + 'pt';
    }

    this.flipCardMessage.style.color = color;
    this.flipCardMessage.style.textAlign = align;
    this.flipCardMessage.style.lineHeight = '1.6';

    // Apply position from text box drag (percentage-based)
    this.flipCardMessage.style.left = `${this.textBoxPosition.x}%`;
    this.flipCardMessage.style.top = `${this.textBoxPosition.y}%`;
    this.flipCardMessage.style.transform = 'translate(-50%, -50%)';

    // Apply size from text box resize (percentage-based)
    this.flipCardMessage.style.width = `${this.textBoxSize.width}%`;
    this.flipCardMessage.style.height = `${this.textBoxSize.height}%`;
  }

  /**
   * Initialize draggable and resizable text box for Step 3
   */
  initDraggableTextBox() {
    if (!this.draggableTextBox || !this.messageCardCanvas) return;

    // Mouse events for dragging
    this.draggableTextBox.addEventListener('mousedown', (e) => this.startTextBoxDrag(e));
    document.addEventListener('mousemove', (e) => {
      this.dragTextBox(e);
      this.resizeTextBox(e);
    });
    document.addEventListener('mouseup', () => {
      this.endTextBoxDrag();
      this.endTextBoxResize();
    });

    // Touch events for dragging - use passive: false to allow preventDefault
    this.draggableTextBox.addEventListener('touchstart', (e) => this.startTextBoxDrag(e), { passive: false });
    document.addEventListener('touchmove', (e) => {
      if (this.isTextBoxDragging || this.isTextBoxResizing) {
        this.dragTextBox(e);
        this.resizeTextBox(e);
      }
    }, { passive: false });
    document.addEventListener('touchend', () => {
      this.endTextBoxDrag();
      this.endTextBoxResize();
    });

    // Initialize resize handles
    this.initTextBoxResizeHandles();

    // Center the text box initially
    this.centerTextBox();
  }

  /**
   * Initialize resize handles for the text box
   */
  initTextBoxResizeHandles() {
    if (!this.draggableTextBox) return;

    const resizeHandles = this.draggableTextBox.querySelectorAll('.text-box-resize-handle');

    resizeHandles.forEach(handle => {
      // Mouse events
      handle.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const direction = handle.dataset.resize;
        if (direction) {
          this.startTextBoxResize(e, direction);
        }
      });

      // Touch events
      handle.addEventListener('touchstart', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const direction = handle.dataset.resize;
        if (direction) {
          this.startTextBoxResize(e, direction);
        }
      }, { passive: false });
    });
  }

  /**
   * Start resizing the text box
   */
  startTextBoxResize(e, direction) {
    this.isTextBoxResizing = true;
    this.resizeDirection = direction;
    this.draggableTextBox.classList.add('resizing');

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const rect = this.messageCardCanvas.getBoundingClientRect();
    const boxRect = this.draggableTextBox.getBoundingClientRect();

    // Store initial state for resizing
    this.textBoxResizeStart = {
      x: clientX,
      y: clientY,
      width: (boxRect.width / rect.width) * 100,
      height: (boxRect.height / rect.height) * 100,
      posX: this.textBoxPosition.x,
      posY: this.textBoxPosition.y
    };

    e.preventDefault();
  }

  /**
   * Resize the text box
   */
  resizeTextBox(e) {
    if (!this.isTextBoxResizing) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const rect = this.messageCardCanvas.getBoundingClientRect();

    // Calculate delta in percentage
    const deltaX = ((clientX - this.textBoxResizeStart.x) / rect.width) * 100;
    const deltaY = ((clientY - this.textBoxResizeStart.y) / rect.height) * 100;

    let newWidth = this.textBoxResizeStart.width;
    let newHeight = this.textBoxResizeStart.height;
    let newPosX = this.textBoxResizeStart.posX;
    let newPosY = this.textBoxResizeStart.posY;

    const minWidth = 20;  // Minimum 20% of canvas
    const minHeight = 15; // Minimum 15% of canvas
    const maxWidth = 95;
    const maxHeight = 90;

    const dir = this.resizeDirection;

    // Handle horizontal resizing
    if (dir.includes('e')) {
      newWidth = Math.max(minWidth, Math.min(maxWidth, this.textBoxResizeStart.width + deltaX * 2));
    }
    if (dir.includes('w')) {
      const widthChange = -deltaX * 2;
      newWidth = Math.max(minWidth, Math.min(maxWidth, this.textBoxResizeStart.width + widthChange));
    }

    // Handle vertical resizing
    if (dir.includes('s')) {
      newHeight = Math.max(minHeight, Math.min(maxHeight, this.textBoxResizeStart.height + deltaY * 2));
    }
    if (dir.includes('n')) {
      const heightChange = -deltaY * 2;
      newHeight = Math.max(minHeight, Math.min(maxHeight, this.textBoxResizeStart.height + heightChange));
    }

    // Update size
    this.textBoxSize = { width: newWidth, height: newHeight };
    this.updateTextBoxSize();

    e.preventDefault();
  }

  /**
   * End resizing the text box
   */
  endTextBoxResize() {
    if (this.isTextBoxResizing) {
      this.isTextBoxResizing = false;
      this.resizeDirection = null;
      this.draggableTextBox.classList.remove('resizing');
    }
  }

  /**
   * Update the text box size visually
   */
  updateTextBoxSize() {
    if (!this.draggableTextBox || !this.messageCardCanvas) return;

    // Set width as percentage
    this.draggableTextBox.style.width = `${this.textBoxSize.width}%`;

    // Calculate height in pixels based on canvas size
    const canvasRect = this.messageCardCanvas.getBoundingClientRect();
    const heightPx = (this.textBoxSize.height / 100) * canvasRect.height;
    this.draggableTextBox.style.height = `${heightPx}px`;
  }

  /**
   * Center the text box in the card and set default size
   */
  centerTextBox() {
    this.textBoxPosition = { x: 50, y: 50 };
    this.textBoxSize = { width: 88, height: 75 };
    this.updateTextBoxPosition();
    // Delay size update to ensure canvas is rendered
    setTimeout(() => {
      this.updateTextBoxSize();
    }, 100);
  }

  /**
   * Update the text box visual position
   */
  updateTextBoxPosition() {
    if (!this.draggableTextBox) return;
    this.draggableTextBox.style.left = `${this.textBoxPosition.x}%`;
    this.draggableTextBox.style.top = `${this.textBoxPosition.y}%`;
    // Sync mobile position sliders
    if (this.posXSlider) this.posXSlider.value = Math.round(this.textBoxPosition.x);
    if (this.posYSlider) this.posYSlider.value = Math.round(this.textBoxPosition.y);
    if (this.posXValue) this.posXValue.textContent = Math.round(this.textBoxPosition.x) + '%';
    if (this.posYValue) this.posYValue.textContent = Math.round(this.textBoxPosition.y) + '%';
  }

  /**
   * Update text box position from mobile sliders
   */
  updateTextBoxFromSliders() {
    if (!this.draggableTextBox) return;
    this.draggableTextBox.style.left = `${this.textBoxPosition.x}%`;
    this.draggableTextBox.style.top = `${this.textBoxPosition.y}%`;
  }

  /**
   * Start dragging the text box
   */
  startTextBoxDrag(e) {
    // Don't start drag if clicking inside textarea or on resize handle
    if (e.target === this.messageEditor) return;
    if (e.target.classList.contains('text-box-resize-handle')) return;

    this.isTextBoxDragging = true;
    this.draggableTextBox.classList.add('dragging');

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const rect = this.messageCardCanvas.getBoundingClientRect();
    const boxRect = this.draggableTextBox.getBoundingClientRect();

    this.textBoxDragStart = {
      x: clientX - boxRect.left + rect.left,
      y: clientY - boxRect.top + rect.top
    };

    e.preventDefault();
  }

  /**
   * Drag the text box
   */
  dragTextBox(e) {
    if (!this.isTextBoxDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const rect = this.messageCardCanvas.getBoundingClientRect();
    const boxRect = this.draggableTextBox.getBoundingClientRect();

    // Calculate new position as percentage
    let newX = ((clientX - this.textBoxDragStart.x + boxRect.width / 2) / rect.width) * 100;
    let newY = ((clientY - this.textBoxDragStart.y + boxRect.height / 2) / rect.height) * 100;

    // Constrain to canvas bounds (with some padding)
    const padding = 5;
    newX = Math.max(padding, Math.min(100 - padding, newX));
    newY = Math.max(padding, Math.min(100 - padding, newY));

    this.textBoxPosition = { x: newX, y: newY };
    this.updateTextBoxPosition();

    e.preventDefault();
  }

  /**
   * End dragging the text box
   */
  endTextBoxDrag() {
    if (this.isTextBoxDragging) {
      this.isTextBoxDragging = false;
      this.draggableTextBox.classList.remove('dragging');
    }
  }

  /**
   * Get a randomly selected default message for the selected gift card type.
   * Each type holds an array of 10 options — one is picked at random each time
   * the user lands on Step 3, keeping the experience fresh.
   */
  getDefaultMessage() {
    if (!this.selectedTemplate) return '';
    const type = this.selectedTemplate.type;
    const messages = this.defaultMessages[type];
    if (!messages) {
      // No category messages — fall back to bakedText alone if present.
      return this.selectedTemplate.bakedText || '';
    }
    let msg;
    if (Array.isArray(messages)) {
      const randomIndex = Math.floor(Math.random() * messages.length);
      msg = messages[randomIndex];
    } else {
      msg = messages;
    }
    // If the card art has baked-on front text (e.g. "Many Thanks"), use it as
    // the inside greeting line so the message echoes the front without forcing
    // the user to rewrite. Replaces only the first line of the random message.
    // Function form avoids $-token interpretation if a future bakedText contains $.
    if (this.selectedTemplate.bakedText) {
      const baked = this.selectedTemplate.bakedText;
      msg = msg.replace(/^[^\n]+/, () => baked);
    }
    return msg;
  }

  /**
   * Set the default message in the editor
   */
  setDefaultMessage() {
    if (!this.messageEditor) return;

    // Always apply a fresh random default when the editor is empty.
    // The editor is cleared in selectTemplate() whenever the card type changes,
    // so switching to a different type always produces a new suggestion here.
    // Switching between cards of the same type preserves any text the user typed.
    if (!this.messageEditor.value.trim()) {
      const defaultMsg = this.getDefaultMessage();
      if (defaultMsg) {
        this.messageEditor.value = defaultMsg;
        this.customMessage = defaultMsg;
      }
    }
  }

  /**
   * Update message card orientation based on selected template
   */
  updateMessageCardOrientation() {
    if (!this.messageCardCanvas || !this.selectedTemplate) return;

    const orientation = this.selectedTemplate.orientation || 'landscape';

    // Remove both classes first
    this.messageCardCanvas.classList.remove('landscape', 'portrait');

    // Add the correct orientation class
    this.messageCardCanvas.classList.add(orientation);
  }

  renderTemplates() {
    // Render category filters
    this.renderCategoryFilters();

    // Render templates grouped by real categories (skip photocard — it's a virtual filter)
    let html = '';

    this.categories.forEach(category => {
      // photocard is a virtual filter, not a real category
      if (category.key === 'photocard') return;

      const categoryTemplates = this.templates.filter(t => t.type === category.key);

      if (categoryTemplates.length > 0) {
        html += `
          <div class="card-category-section" data-category="${category.key}">
            <h3 class="card-category-title">${category.label}</h3>
            <div class="card-category-row">
              ${categoryTemplates.map(template => this.templateTileHtml(template)).join('')}
            </div>
          </div>
        `;
      }
    });

    this.templatesGrid.innerHTML = html;

    this.templatesGrid.querySelectorAll('.card-template-item').forEach(item => {
      // Single click/tap selects the card and moves straight to the next step
      const choose = () => {
        this.selectTemplate(item.dataset.templateId);
        this.nextStep();
      };
      item.addEventListener('click', choose);
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choose();
        }
      });
    });

    // Re-rendering (e.g. when the catalogue arrives late) must not lose the
    // shopper's filter or the highlight on the card they already chose.
    if (this.activeFilter && this.activeFilter !== 'all') {
      this.filterByCategory(this.activeFilter);
    }
    if (this.selectedTemplate) {
      const chosen = this.templatesGrid.querySelector(`[data-template-id="${this.selectedTemplate.id}"]`);
      if (chosen) chosen.classList.add('selected');
    }
  }

  escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /**
   * Picker tile for one template. Photo-capable cards carry an "Upload Image"
   * badge over their photo area so shoppers can tell at a glance which cards
   * take a photo (few discover the "Photo Card" filter on their own).
   */
  templateTileHtml(template) {
    const badge = template.hasPhoto ? this.uploadBadgeHtml(template) : '';
    const orientationWord = template.orientation === 'landscape' ? 'horizontal' : 'vertical';
    if (template.source === 'blank') {
      return `
        <div class="card-template-item card-template-blank" data-template-id="${template.id}" data-has-photo="true"
             role="button" tabindex="0" aria-label="Blank card, ${orientationWord}, upload your own image">
          <div class="card-template-thumb">
            <div class="card-blank-face ${template.orientation}">${badge}</div>
          </div>
          <div class="card-template-info">
            <p class="card-template-name">${template.name}</p>
            <p class="card-template-sub">${template.subtitle || ''}</p>
          </div>
        </div>`;
    }
    const label = `${this.escapeHtml(template.name)}${template.hasPhoto ? ', photo card' : ''}`;
    return `
      <div class="card-template-item" data-template-id="${template.id}" data-has-photo="${template.hasPhoto}"
           role="button" tabindex="0" aria-label="${label}">
        <div class="card-template-thumb">
          <img src="${this.getThumbnailUrl(template)}" alt="${template.name}" loading="lazy" decoding="async" crossorigin="anonymous">
          ${badge}
        </div>
        <div class="card-template-info">
          <p class="card-template-name">${template.name}</p>
        </div>
      </div>`;
  }

  /**
   * "Upload Image" badge, placed over the card's photo slot when the slot is
   * known. Thumbnails are object-fit: cover in a (near) square box: the art is
   * scaled to the box's short side and cropped on the long axis, centred, so
   * the slot centre is mapped through that same scale-and-crop. Legacy cards
   * carry no slot geometry and get a centred badge.
   */
  uploadBadgeHtml(template) {
    let left = 50;
    let top = 50;
    if (template.source !== 'blank' && template.photoSlot && template.canvas) {
      const { width: w, height: h } = template.canvas;
      const { x: cx, y: cy } = template.photoSlot.center;
      if (w < h) {
        // Portrait: scaled to the box width, cropped top and bottom.
        const shownH = h / w;
        left = (cx / w) * 100;
        top = (cy / w - (shownH - 1) / 2) * 100;
      } else {
        // Landscape: scaled to the box height, cropped left and right.
        const shownW = w / h;
        left = (cx / h - (shownW - 1) / 2) * 100;
        top = (cy / h) * 100;
      }
      // The pill is ~110px wide in a ~176px tile, so its centre must stay well
      // inside horizontally; vertically it is short and can sit nearer the edge.
      left = Math.min(68, Math.max(32, left));
      top = Math.min(85, Math.max(15, top));
    }
    // clamp() keeps the whole pill inside the tile whatever its pixel width
    // (half the pill plus a little air); the percentages above are the fallback.
    const pos = `left:clamp(64px, ${left.toFixed(1)}%, calc(100% - 64px));top:clamp(18px, ${top.toFixed(1)}%, calc(100% - 18px))`;
    return `
      <span class="card-upload-badge" style="${pos}" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
        <span>Upload Image</span>
      </span>`;
  }

  /**
   * Render category filter buttons
   */
  renderCategoryFilters() {
    if (!this.categoryFilters) return;

    let html = `<button type="button" class="card-filter-btn active" data-filter="all">All</button>`;

    this.categories.forEach(category => {
      if (category.key === 'photocard') {
        // Photocard is a virtual filter — count all templates with hasPhoto
        const count = this.templates.filter(t => t.hasPhoto).length;
        if (count > 0) {
          html += `<button type="button" class="card-filter-btn" data-filter="photocard">${category.label}</button>`;
        }
      } else {
        const count = this.templates.filter(t => t.type === category.key).length;
        if (count > 0) {
          html += `<button type="button" class="card-filter-btn" data-filter="${category.key}">${category.label}</button>`;
        }
      }
    });

    this.categoryFilters.innerHTML = html;

    // Add click events to filter buttons
    this.categoryFilters.querySelectorAll('.card-filter-btn').forEach(btn => {
      btn.addEventListener('click', () => this.filterByCategory(btn.dataset.filter));
    });
  }

  /**
   * Filter templates by category
   */
  filterByCategory(categoryKey) {
    this.activeFilter = categoryKey;

    // Update active button state
    this.categoryFilters.querySelectorAll('.card-filter-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.filter === categoryKey);
    });

    if (categoryKey === 'photocard') {
      // Photocard filter: show all sections, but hide individual items without hasPhoto
      this.templatesGrid.querySelectorAll('.card-category-section').forEach(section => {
        const items = section.querySelectorAll('.card-template-item');
        let visibleCount = 0;
        items.forEach(item => {
          const hasPhoto = item.dataset.hasPhoto === 'true';
          item.style.display = hasPhoto ? '' : 'none';
          if (hasPhoto) visibleCount++;
        });
        // Hide entire section if it has no photo cards
        section.style.display = visibleCount === 0 ? 'none' : '';
      });
    } else {
      // Normal category filter: show/hide entire sections, ensure all items visible
      this.templatesGrid.querySelectorAll('.card-category-section').forEach(section => {
        if (categoryKey === 'all') {
          section.style.display = '';
        } else {
          section.style.display = section.dataset.category === categoryKey ? '' : 'none';
        }
        // Reset any hidden individual items from a previous photocard filter
        section.querySelectorAll('.card-template-item').forEach(item => {
          item.style.display = '';
        });
      });
    }
  }

  selectTemplate(templateId) {
    this.templatesGrid.querySelectorAll('.card-template-item').forEach(item => {
      item.classList.remove('selected');
    });

    const selectedItem = this.templatesGrid.querySelector(`[data-template-id="${templateId}"]`);
    selectedItem.classList.add('selected');

    // Remember the previous template so we know whether to clear message / reset photo state.
    const previousType = this.selectedTemplate ? this.selectedTemplate.type : null;
    const previousId = this.selectedTemplate ? this.selectedTemplate.id : null;

    this.selectedTemplate = this.templates.find(t => t.id === templateId);

    // If the card type changed, clear any existing message so a fresh
    // random default for the new type is inserted when the user reaches Step 3
    if (previousType !== this.selectedTemplate.type) {
      this.customMessage = '';
      if (this.messageEditor) {
        this.messageEditor.value = '';
      }
    }

    // Switching to a different card resets drag/zoom/rotation — otherwise the
    // user's offset for the previous slot lands the photo in the wrong place
    // on the new card.
    if (previousId !== null && previousId !== this.selectedTemplate.id) {
      this.photoPosition = { x: 0, y: 0 };
      this.zoom = 100;
      this.rotation = 0;
      if (this.zoomSlider) this.zoomSlider.value = 1;
      if (this.zoomSliderMobile) this.zoomSliderMobile.value = 1;
      if (this.zoomValue) this.zoomValue.textContent = '100%';
    }
    this.setBlankFitMode('cover', { render: false });
    this.updateBlankControls();

    // If the new card doesn't allow photos, drop any uploaded one so it
    // doesn't render hidden behind a no-photo card's overlay.
    if (this.hasPhoto && this.selectedTemplate.canCustom === false) {
      this.removePhoto();
    }

    if (this.selectedTemplatePreview) {
      // Blank cards have no art: show a plain white face behind the add-photo button.
      this.selectedTemplatePreview.src = this.selectedTemplate.overlayImage || this.blankFaceDataUri();
    }

    // Refresh canvas if photo exists
    if (this.hasPhoto) {
      this.renderPhotoPreview();
    }

    if (this.selectedTemplate.overlayImage) {
      // Auto-detect orientation from the image dimensions
      this.detectTemplateOrientation(this.selectedTemplate.overlayImage);
    } else {
      this.applyTemplateOrientation(this.selectedTemplate.orientation || 'portrait');
    }
  }

  /** A 1-colour white image for the Step 2 preview of a card with no artwork. */
  blankFaceDataUri() {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><rect width="10" height="10" fill="#ffffff"/></svg>'
    );
  }

  /** Put the orientation class on the Step 2 card display. */
  applyTemplateOrientation(orientation) {
    if (this.cardDisplayInner) {
      this.cardDisplayInner.classList.remove('landscape', 'portrait');
      this.cardDisplayInner.classList.add(orientation);
    }
  }

  /** Cards whose photo is clipped to a declared slot (new catalogue + blank). */
  templateUsesSlot(tpl) {
    return !!(tpl && (tpl.source === 'new-gift' || tpl.source === 'blank') && tpl.photoSlot && tpl.canvas);
  }

  /** Blank cards fill their panel exactly; artwork slots get the usual inflation. */
  slotInflationFor(tpl) {
    if (tpl && tpl.source === 'blank') return 1;
    return this.slotInflation || 1;
  }

  /** Name shown in the cart and summary ("Blank Card (Vertical)" beats "Vertical"). */
  templateDisplayName(tpl) {
    return tpl.cartName || tpl.name;
  }

  /**
   * Detect image orientation by loading it and checking dimensions
   * @param {string} imageUrl - URL of the template image
   */
  detectTemplateOrientation(imageUrl) {
    // The probe is async; the shopper may pick another card before it lands.
    const probed = this.selectedTemplate;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      if (this.selectedTemplate !== probed) return;
      // Determine orientation based on image dimensions
      let orientation = img.naturalWidth > img.naturalHeight ? 'landscape' : 'portrait';

      // Respect manual orientation if set in template config
      if (this.selectedTemplate && this.selectedTemplate.orientation) {
        orientation = this.selectedTemplate.orientation;
      } else if (this.selectedTemplate) {
        // Otherwise save the detected one
        this.selectedTemplate.orientation = orientation;
      }

      // Update the card display if in Step 2
      this.applyTemplateOrientation(orientation);

      console.log(`Template orientation detected: ${orientation} (${img.naturalWidth}x${img.naturalHeight})`);
    };
    img.onerror = () => {
      // Default to landscape only for the probed template and only when it
      // carries no explicit orientation of its own.
      if (this.selectedTemplate === probed && probed && !probed.orientation) {
        probed.orientation = 'landscape';
      }
    };
    img.src = imageUrl;
  }

  handlePhotoUpload(e) {
    const file = e.target.files && e.target.files[0];
    // Clear the input so the same file can be chosen again after a rejection
    // or a Remove; the File object stays valid.
    e.target.value = '';
    if (!file) return;
    if (!this.isImageFile(file)) {
      this.showNotification('Please choose a photo file (JPG, PNG, GIF or WebP).', 'error');
      return;
    }
    if (file.size > this.maxUploadBytes) {
      const mb = (file.size / 1048576).toFixed(1);
      const cap = Math.round(this.maxUploadBytes / 1048576);
      this.showNotification(`This image is ${mb}MB. Please choose one under ${cap}MB.`, 'error');
      return;
    }
    this.processPhoto(file);
  }

  /** Some pickers hand over a photo with an empty type; fall back to the file name. */
  isImageFile(file) {
    if (file.type) return file.type.startsWith('image/');
    return /\.(jpe?g|png|gif|webp|bmp|avif|heic|heif|svg)$/i.test(file.name || '');
  }

  processPhoto(file) {
    const type = file.type || 'image/jpeg';
    // An object URL, not a data URL: a 24MP phone photo read as base64 is a
    // ~10MB string the browser holds on top of the decoded bitmap, which is
    // what iOS Safari runs out of room for. applyUploadedPhoto() takes the URL
    // over when the photo lands on the card and revokes it when it leaves.
    const sourceUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      this.fitPhotoToBudget(img, type, sourceUrl)
        .then(({ image, mimeType, objectUrl }) => {
          if (objectUrl !== sourceUrl) URL.revokeObjectURL(sourceUrl);
          this.applyUploadedPhoto(image, mimeType, { objectUrl });
        })
        .catch(() => {
          URL.revokeObjectURL(sourceUrl);
          this.showNotification('We could not prepare that photo. Please try another one.', 'error');
        });
    };
    // A HEIC on a browser that cannot decode it, or a file that is not really
    // an image: say so instead of silently doing nothing.
    img.onerror = () => {
      URL.revokeObjectURL(sourceUrl);
      this.showNotification('We could not open that image. Please use a JPG or PNG photo.', 'error');
    };
    img.src = sourceUrl;
  }

  /**
   * Scale an oversized upload down to maxPhotoEdge on its long side. Resolves
   * to an HTMLImageElement either way, so the cropper, the save-for-later
   * store and the print render all see the same kind of object. The scaled
   * copy lives on an object URL that applyUploadedPhoto() keeps for as long
   * as the photo is on the card (Safari may re-decode from src under memory
   * pressure). Drawing through a canvas also bakes in the EXIF orientation
   * the browser applied on decode.
   */
  fitPhotoToBudget(img, mimeType, sourceUrl = null) {
    const w = img.naturalWidth || img.width;
    const h = img.naturalHeight || img.height;
    const longest = Math.max(w, h);
    if (!longest || longest <= this.maxPhotoEdge || mimeType === 'image/svg+xml') {
      return Promise.resolve({ image: img, mimeType, objectUrl: sourceUrl });
    }
    // The scaled copy is drawn through a canvas, so it has to fit the canvas
    // budget as well as the long edge. Floor, never round, so the area stays
    // under the cap.
    const k = Math.min(this.maxPhotoEdge / longest, Math.sqrt(this.maxCanvasPixels / (w * h)));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.floor(w * k));
    canvas.height = Math.max(1, Math.floor(h * k));
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    // Only a JPEG source is re-encoded as JPEG; anything else may carry transparency.
    const outType = mimeType === 'image/jpeg' ? 'image/jpeg' : 'image/png';
    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) { reject(new Error('Could not encode the scaled photo')); return; }
        const url = URL.createObjectURL(blob);
        const scaled = new Image();
        scaled.onload = () => resolve({ image: scaled, mimeType: outType, objectUrl: url });
        scaled.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not decode the scaled photo')); };
        scaled.src = url;
      }, outType, 0.95);
    });
  }

  /** Make an already-loaded image the card photo and open the editing state. */
  applyUploadedPhoto(img, mimeType, { fromSaved = false, objectUrl = null } = {}) {
    this.closeCropper();
    this.releasePhotoObjectUrl();
    this._photoObjectUrl = objectUrl;
    this.uploadedPhoto = img;
    this.originalPhoto = img;
    this._cropBakedRotation = 0;
    this.cropRect = null;
    this.uploadedPhotoType = mimeType || 'image/jpeg';
    this.hasPhoto = true;
    this._photoFromSaved = fromSaved;
    this._savedThisSession = false;
    this._editExpectsPhoto = false;
    this.resetPosition();

    // Hide add photo overlay and show edit controls
    if (this.photoPlaceholder) this.photoPlaceholder.style.display = 'none';
    if (this.photoInitialState) this.photoInitialState.style.display = 'none';
    if (this.photoEditState) this.photoEditState.style.display = 'flex';

    // Show canvas and instructions
    if (this.cardCanvas) {
      this.cardCanvas.style.display = 'block';
      this.cardCanvas.classList.add('active');
    }

    // A fresh upload offers the save toggle; the saved image itself shows a note instead.
    if (this.saveImageToggle) this.saveImageToggle.checked = false;
    this.updateSaveControls();

    // Show instructions overlay for first-time users
    this.showPhotoInstructions();

    this.renderPhotoPreview();
  }

  showPhotoInstructions() {
    if (this.photoInstructions) {
      this.photoInstructions.classList.add('visible');
    }
  }

  hidePhotoInstructions() {
    if (this.photoInstructions) {
      this.photoInstructions.classList.remove('visible');
    }
  }

  finishPhotoEditing() {
    // Hide instructions if showing
    this.hidePhotoInstructions();
    // Go to next step
    this.nextStep();
  }

  removePhoto() {
    this.closeCropper();
    this.uploadedPhoto = null;
    this.originalPhoto = null;
    this._cropBakedRotation = 0;
    this.cropRect = null;
    this.hasPhoto = false;
    this.photoInput.value = '';

    // Hide canvas and show add photo overlay
    if (this.cardCanvas) {
      this.cardCanvas.style.display = 'none';
      this.cardCanvas.classList.remove('active');
    }
    if (this.photoPlaceholder) this.photoPlaceholder.style.display = 'flex';

    // Show static template preview again
    if (this.selectedTemplatePreview) {
      this.selectedTemplatePreview.style.display = 'block';
    }

    // Show initial state, hide edit controls
    if (this.photoInitialState) this.photoInitialState.style.display = 'flex';
    if (this.photoEditState) this.photoEditState.style.display = 'none';
    this.releasePhotoObjectUrl();
    this._photoFromSaved = false;
    this._savedThisSession = false;
    this.refreshSavedImageUi();

    // Hide instructions
    this.hidePhotoInstructions();
  }

  // ---------------------------------------------------------------------------
  // Saved image: a business can keep its logo (or any photo) in this browser
  // and reuse it on later orders without uploading again. Stored in IndexedDB
  // under a single key; nothing leaves the device and no account is needed.
  // (An account-backed version would need server-side storage per customer.)
  // ---------------------------------------------------------------------------

  savedImageDb() {
    if (!this._savedImageDb) {
      this._savedImageDb = new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
          reject(new Error('IndexedDB unavailable'));
          return;
        }
        const request = indexedDB.open('mp-greeting-card', 1);
        request.onupgradeneeded = () => request.result.createObjectStore('saved-images');
        request.onsuccess = () => {
          const db = request.result;
          // Drop the cached connection if the browser closes it, and never
          // block a future schema bump from another tab.
          db.onclose = () => { this._savedImageDb = null; };
          db.onversionchange = () => { db.close(); this._savedImageDb = null; };
          resolve(db);
        };
        request.onerror = () => reject(request.error);
      }).catch(error => {
        this._savedImageDb = null;
        throw error;
      });
    }
    return this._savedImageDb;
  }

  /** Run one request and settle when the TRANSACTION completes, not when the
   *  request reports success: a quota failure can still abort at commit. */
  async savedImageStore(mode, run) {
    const db = await this.savedImageDb();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('saved-images', mode);
      let result;
      const request = run(tx.objectStore('saved-images'));
      request.onsuccess = () => { result = request.result; };
      tx.oncomplete = () => resolve(result);
      tx.onerror = () => reject(tx.error || request.error);
      tx.onabort = () => reject(tx.error || new Error('IndexedDB transaction aborted'));
    });
  }

  /** Blob-URL bookkeeping for a photo loaded from the saved-image store. */
  releasePhotoObjectUrl() {
    if (this._photoObjectUrl) {
      URL.revokeObjectURL(this._photoObjectUrl);
      this._photoObjectUrl = null;
    }
  }

  /** Save toggle for fresh uploads; a note instead when the photo IS the saved image. */
  updateSaveControls() {
    if (this.saveImageLabel) {
      this.saveImageLabel.style.display = this._photoFromSaved ? 'none' : '';
    }
    if (this.savedImageNote) {
      this.savedImageNote.classList.toggle('visible', !!this._photoFromSaved);
    }
  }

  /** Blank-only Step 2 controls: the fit/fill choice and the "leave it blank" hint. */
  updateBlankControls() {
    const blank = !!(this.selectedTemplate && this.selectedTemplate.source === 'blank');
    if (this.fitToggle) {
      this.fitToggle.classList.toggle('visible', blank);
      this.fitToggle.querySelectorAll('[data-fit-mode]').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.fitMode === this.blankFitMode);
        btn.setAttribute('aria-pressed', btn.dataset.fitMode === this.blankFitMode ? 'true' : 'false');
      });
    }
    if (this.blankHint) {
      this.blankHint.classList.toggle('visible', blank);
    }
  }

  setBlankFitMode(mode, { render = true } = {}) {
    this.blankFitMode = mode === 'contain' ? 'contain' : 'cover';
    this.updateBlankControls();
    if (render && this.hasPhoto) {
      this.photoPosition = { x: 0, y: 0 };
      this.renderPhotoPreview();
    }
  }

  /** The stored record, normalised to { blob, type, savedAt } or null. */
  async getSavedImage() {
    try {
      const record = await this.savedImageStore('readonly', store => store.get('logo'));
      if (!record) return null;
      // Bytes are stored as an ArrayBuffer: WebKit cannot put a Blob into
      // IndexedDB ("BlobURLs are not yet supported"), buffers work everywhere.
      const blob = record.blob instanceof Blob
        ? record.blob
        : (record.bytes ? new Blob([record.bytes], { type: record.type || 'image/png' }) : null);
      return blob ? { blob, type: record.type || blob.type, savedAt: record.savedAt } : null;
    } catch (error) {
      return null;
    }
  }

  /** Show or hide the "Use my saved image" control depending on what is stored. */
  async refreshSavedImageUi() {
    if (!this.savedImageBlock) return;
    const saved = await this.getSavedImage();
    if (this._savedImageUrl) {
      URL.revokeObjectURL(this._savedImageUrl);
      this._savedImageUrl = null;
    }
    if (saved && saved.blob) {
      this._savedImageUrl = URL.createObjectURL(saved.blob);
      if (this.savedImageThumb) this.savedImageThumb.src = this._savedImageUrl;
      this.savedImageBlock.style.display = '';
    } else {
      this.savedImageBlock.style.display = 'none';
    }
  }

  /** Keep the current photo for future orders (re-encoded so it stores fast). */
  async saveCurrentImage() {
    if (!this.uploadedPhoto) return;
    // Sequence guard: a quick tick/untick must not leave a stale save behind.
    const seq = (this._saveSeq = (this._saveSeq || 0) + 1);
    const stillWanted = () => seq === this._saveSeq && this.saveImageToggle && this.saveImageToggle.checked;
    try {
      const img = this.uploadedPhoto;
      const maxEdge = 2400;
      const longest = Math.max(img.width, img.height) || 1;
      // Rasters are downscaled; an SVG (tiny intrinsic size) is upscaled so
      // the stored copy still prints crisply.
      const isVector = this.uploadedPhotoType === 'image/svg+xml';
      const scale = isVector ? maxEdge / longest : Math.min(1, maxEdge / longest);
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(img.width * scale));
      canvas.height = Math.max(1, Math.round(img.height * scale));
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      // Only a JPEG source is stored as JPEG; everything else may carry
      // transparency, which JPEG would flatten onto black.
      const type = this.uploadedPhotoType === 'image/jpeg' ? 'image/jpeg' : 'image/png';
      const blob = await new Promise(resolve => canvas.toBlob(resolve, type, 0.92));
      if (!blob) throw new Error('Could not encode image');
      const bytes = await blob.arrayBuffer();
      if (!stillWanted()) return;
      if (navigator.storage && navigator.storage.persist) {
        // Best effort: asks the browser not to evict this origin's storage.
        navigator.storage.persist().catch(() => {});
      }
      const previous = await this.getSavedImage();
      if (!stillWanted()) return;
      await this.savedImageStore('readwrite', store => store.put({ bytes, type, savedAt: Date.now() }, 'logo'));
      if (seq !== this._saveSeq) return;
      this._savedThisSession = true;
      this.showNotification(previous
        ? 'Image saved in this browser for next time (replaced your previous saved image)'
        : 'Image saved in this browser for next time', 'success');
      this.refreshSavedImageUi();
    } catch (error) {
      console.error('Could not save image:', error);
      if (this.saveImageToggle) this.saveImageToggle.checked = false;
      this.showNotification('Could not save the image in this browser', 'error');
    }
  }

  async forgetSavedImage({ announce = false } = {}) {
    this._saveSeq = (this._saveSeq || 0) + 1;
    this._savedThisSession = false;
    try {
      await this.savedImageStore('readwrite', store => store.delete('logo'));
      if (announce) this.showNotification('Saved image removed', 'success');
    } catch (error) {
      console.error('Could not remove saved image:', error);
    }
    if (this.saveImageToggle) this.saveImageToggle.checked = false;
    this.refreshSavedImageUi();
  }

  /** Load the stored image as the card photo. */
  async useSavedImage() {
    const saved = await this.getSavedImage();
    if (!saved || !saved.blob) {
      this.refreshSavedImageUi();
      return;
    }
    const url = URL.createObjectURL(saved.blob);
    const img = new Image();
    // The object URL is kept while this image is the card photo and released
    // by applyUploadedPhoto()/removePhoto() when it is replaced.
    img.onload = () => this.applyUploadedPhoto(img, saved.type, { fromSaved: true, objectUrl: url });
    img.onerror = () => {
      URL.revokeObjectURL(url);
      this.showNotification('Saved image could not be loaded', 'error');
    };
    img.src = url;
  }

  // ---------------------------------------------------------------------------
  // Crop: trims the uploaded image (and bakes in any rotation) before it goes
  // on the card. The original upload is kept untouched so every crop starts
  // from the whole image; the cropped copy is what the card preview, the print
  // render and the "save for next time" store all use.
  // ---------------------------------------------------------------------------

  bindCropperEvents() {
    const overlay = this.cropOverlay;
    if (!overlay || !this.cropStage || !this.cropBox) return;

    document.querySelectorAll(`[data-crop-photo="${this.id}"]`).forEach(btn => {
      btn.addEventListener('click', () => this.openCropper(btn));
    });
    overlay.querySelectorAll('[data-crop-aspect]').forEach(btn => {
      btn.addEventListener('click', () => this.setCropAspect(btn.dataset.cropAspect));
    });
    const onClick = (selector, handler) => {
      const el = overlay.querySelector(selector);
      if (el) el.addEventListener('click', handler);
    };
    onClick('[data-crop-rotate]', () => this.rotateInCropper());
    onClick('[data-crop-reset]', () => this.resetCropRect());
    onClick('[data-crop-cancel]', () => this.closeCropper());
    onClick('[data-crop-apply]', () => this.applyCrop());
    overlay.addEventListener('keydown', (e) => this.onCropKeydown(e));

    // Pointer events cover mouse, touch and pen; the stage captures the
    // pointer so a drag that leaves the box (or the modal) keeps tracking.
    this.cropStage.addEventListener('pointerdown', (e) => this.onCropPointerDown(e));
    this.cropStage.addEventListener('pointermove', (e) => this.onCropPointerMove(e));
    this.cropStage.addEventListener('pointerup', (e) => this.onCropPointerUp(e));
    this.cropStage.addEventListener('pointercancel', (e) => this.onCropPointerUp(e));
    window.addEventListener('resize', () => {
      if (this._crop) this.layoutCropStage();
    });
  }

  /** Open the crop overlay on the current photo, turned as it is on the card. */
  openCropper(trigger) {
    if (!this.originalPhoto || !this.cropOverlay || this._crop) return;
    const rotation = (this._cropBakedRotation + this.rotation) % 360;
    const source = this.buildCropSource(rotation);
    if (!source) return;

    // Start from the previous crop, carried through any turn added since, so
    // reopening the cropper shows the box where the shopper left it.
    let srcRect = { x: 0, y: 0, w: source.width, h: source.height };
    const prev = this.cropRect;
    if (prev) {
      let rect = { x: prev.x, y: prev.y, w: prev.w, h: prev.h };
      let frame = this.cropSourceSize(prev.rotation);
      for (let turns = ((rotation - prev.rotation + 360) % 360) / 90; frame && turns > 0; turns--) {
        rect = this.rotateRectCw(rect, frame.height);
        frame = { width: frame.height, height: frame.width };
      }
      srcRect = rect;
    }

    this._cropReturnFocus = trigger || null;
    this._crop = {
      source, rotation, srcRect,
      rect: null, aspect: 'free', ratio: null, drag: null,
      scale: 1, offset: { x: 0, y: 0 }, dispW: 0, dispH: 0
    };
    this.hidePhotoInstructions();
    this.cropOverlay.classList.add('active');
    this.updateCropAspectButtons();
    this.layoutCropStage();
    this.cropBox.focus({ preventScroll: true });
  }

  closeCropper() {
    const c = this._crop;
    if (!c) return;
    if (c.drag) {
      try { this.cropStage.releasePointerCapture(c.drag.pointerId); } catch (error) { /* already released */ }
    }
    this._crop = null;
    this.cropOverlay.classList.remove('active');
    this.cropBox.classList.remove('dragging');
    // Drop the on-screen copy; the next open redraws it.
    this.cropCanvas.width = 1;
    this.cropCanvas.height = 1;
    const back = this._cropReturnFocus;
    this._cropReturnFocus = null;
    if (back && typeof back.focus === 'function' && back.offsetParent !== null) {
      back.focus({ preventScroll: true });
    }
  }

  /**
   * Pixel size of the crop source: the original turned by `rotation`.
   * Rasters are used pixel for pixel, capped to maxCanvasPixels so a huge
   * photo cannot outgrow what a phone will back with a canvas; an SVG is
   * rasterised large enough to print crisply at 600 DPI.
   */
  cropSourceSize(rotation) {
    const img = this.originalPhoto;
    if (!img) return null;
    const w = img.naturalWidth || img.width;
    const h = img.naturalHeight || img.height;
    if (!w || !h) return null;
    const isVector = this.uploadedPhotoType === 'image/svg+xml';
    let k = isVector ? 4800 / Math.max(w, h) : 1;
    k = Math.min(k, Math.sqrt(this.maxCanvasPixels / (w * h)));
    // Floor, never round: rounding both edges up can carry the area back over
    // maxCanvasPixels, which is the one thing this scale exists to prevent.
    const drawW = Math.max(1, Math.floor(w * k));
    const drawH = Math.max(1, Math.floor(h * k));
    const swap = rotation % 180 !== 0;
    return { width: swap ? drawH : drawW, height: swap ? drawW : drawH, drawW, drawH };
  }

  /** The original upload turned by `rotation` (a multiple of 90°), as a canvas. */
  buildCropSource(rotation) {
    const size = this.cropSourceSize(rotation);
    if (!size) return null;
    const canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.drawImage(this.originalPhoto, -size.drawW / 2, -size.drawH / 2, size.drawW, size.drawH);
    return canvas;
  }

  /** A rectangle carried through a 90° clockwise turn of a frame `frameH` tall. */
  rotateRectCw(rect, frameH) {
    return { x: frameH - rect.y - rect.h, y: rect.x, w: rect.h, h: rect.w };
  }

  /** Fit the source into the stage and place the crop box over it. */
  layoutCropStage() {
    const c = this._crop;
    if (!c) return;
    const stageW = this.cropStage.clientWidth;
    const stageH = this.cropStage.clientHeight;
    if (!stageW || !stageH) return;
    // Air around the image so the corner handles (which overhang the box by
    // up to 20px on touch screens) stay reachable when the box is at the edge.
    const pad = 22;
    const roomW = Math.max(1, stageW - pad * 2);
    const roomH = Math.max(1, stageH - pad * 2);
    c.scale = Math.min(roomW / c.source.width, roomH / c.source.height);
    c.dispW = Math.max(1, Math.round(c.source.width * c.scale));
    c.dispH = Math.max(1, Math.round(c.source.height * c.scale));
    c.offset = { x: Math.floor((stageW - c.dispW) / 2), y: Math.floor((stageH - c.dispH) / 2) };

    // Drawn at device resolution so it stays sharp on HiDPI screens.
    const dpr = window.devicePixelRatio || 1;
    const canvas = this.cropCanvas;
    canvas.width = Math.round(c.dispW * dpr);
    canvas.height = Math.round(c.dispH * dpr);
    canvas.style.width = `${c.dispW}px`;
    canvas.style.height = `${c.dispH}px`;
    canvas.style.left = `${c.offset.x}px`;
    canvas.style.top = `${c.offset.y}px`;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(c.source, 0, 0, canvas.width, canvas.height);

    const s = c.scale;
    const r = c.srcRect;
    this.setCropRect(this.clampCropRect({ x: r.x * s, y: r.y * s, w: r.w * s, h: r.h * s }));
  }

  cropMinSize() {
    const c = this._crop;
    return Math.min(24, c.dispW, c.dispH);
  }

  /** Keep a stage-space rectangle inside the image and no smaller than the minimum. */
  clampCropRect(rect) {
    const c = this._crop;
    const min = this.cropMinSize();
    const w = Math.min(Math.max(rect.w, min), c.dispW);
    const h = Math.min(Math.max(rect.h, min), c.dispH);
    return {
      x: Math.min(Math.max(rect.x, 0), c.dispW - w),
      y: Math.min(Math.max(rect.y, 0), c.dispH - h),
      w,
      h
    };
  }

  /** Store the crop box (stage space), mirror it to source space and the DOM. */
  setCropRect(rect) {
    const c = this._crop;
    if (!c) return;
    c.rect = rect;
    c.srcRect = { x: rect.x / c.scale, y: rect.y / c.scale, w: rect.w / c.scale, h: rect.h / c.scale };
    const style = this.cropBox.style;
    style.left = `${c.offset.x + rect.x}px`;
    style.top = `${c.offset.y + rect.y}px`;
    style.width = `${rect.w}px`;
    style.height = `${rect.h}px`;
    this.updateCropQualityNote();
  }

  /**
   * Resize from one handle ("n", "se", ...) by a pointer delta. The edges
   * not being dragged stay put; with a locked shape an edge-only drag keeps
   * the box centred on the other axis.
   */
  resizeCropRect(start, handle, dx, dy) {
    const c = this._crop;
    const min = this.cropMinSize();
    const hasW = handle.includes('w');
    const hasE = handle.includes('e');
    const hasN = handle.includes('n');
    const hasS = handle.includes('s');
    let left = start.x;
    let top = start.y;
    let right = start.x + start.w;
    let bottom = start.y + start.h;
    if (hasW) left = Math.min(Math.max(0, left + dx), right - min);
    if (hasE) right = Math.max(Math.min(c.dispW, right + dx), left + min);
    if (hasN) top = Math.min(Math.max(0, top + dy), bottom - min);
    if (hasS) bottom = Math.max(Math.min(c.dispH, bottom + dy), top + min);
    if (!c.ratio) return { x: left, y: top, w: right - left, h: bottom - top };

    const ratio = c.ratio;
    let w = right - left;
    let h = bottom - top;
    if (hasW || hasE) {
      if (hasN || hasS) {
        // Corner: the box stays inside the pointer's extent.
        if (w / h > ratio) w = h * ratio; else h = w / ratio;
      } else {
        h = w / ratio;
      }
    } else {
      w = h * ratio;
    }
    const cx = start.x + start.w / 2;
    const cy = start.y + start.h / 2;
    const maxW = hasW ? right : hasE ? c.dispW - left : 2 * Math.min(cx, c.dispW - cx);
    const maxH = hasN ? bottom : hasS ? c.dispH - top : 2 * Math.min(cy, c.dispH - cy);
    const roomW = Math.min(maxW, maxH * ratio);
    w = Math.min(Math.max(w, Math.max(min, min * ratio)), roomW);
    h = w / ratio;
    return {
      x: hasW ? right - w : hasE ? left : cx - w / 2,
      y: hasN ? bottom - h : hasS ? top : cy - h / 2,
      w,
      h
    };
  }

  onCropPointerDown(e) {
    const c = this._crop;
    if (!c || c.drag || (e.pointerType === 'mouse' && e.button !== 0)) return;
    if (!(e.target instanceof Element)) return;
    const handle = e.target.closest('[data-crop-handle]');
    const mode = handle ? handle.dataset.cropHandle : (e.target.closest('.card-crop-box') ? 'move' : null);
    if (!mode) return;
    c.drag = { mode, pointerId: e.pointerId, startX: e.clientX, startY: e.clientY, start: { ...c.rect } };
    try { this.cropStage.setPointerCapture(e.pointerId); } catch (error) { /* older WebKit */ }
    this.cropBox.classList.add('dragging');
    e.preventDefault();
  }

  onCropPointerMove(e) {
    const c = this._crop;
    if (!c || !c.drag || e.pointerId !== c.drag.pointerId) return;
    const dx = e.clientX - c.drag.startX;
    const dy = e.clientY - c.drag.startY;
    const start = c.drag.start;
    if (c.drag.mode === 'move') {
      this.setCropRect(this.clampCropRect({ x: start.x + dx, y: start.y + dy, w: start.w, h: start.h }));
    } else {
      this.setCropRect(this.resizeCropRect(start, c.drag.mode, dx, dy));
    }
    e.preventDefault();
  }

  onCropPointerUp(e) {
    const c = this._crop;
    if (!c || !c.drag || e.pointerId !== c.drag.pointerId) return;
    try { this.cropStage.releasePointerCapture(e.pointerId); } catch (error) { /* already released */ }
    c.drag = null;
    this.cropBox.classList.remove('dragging');
  }

  onCropKeydown(e) {
    const c = this._crop;
    if (!c) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      this.closeCropper();
      return;
    }
    if (e.key === 'Tab') {
      // Keep focus inside the overlay while it is open.
      const focusable = [...this.cropOverlay.querySelectorAll('button, [tabindex="0"]')].filter(el => !el.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
      return;
    }
    if (e.target !== this.cropBox) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      this.applyCrop();
      return;
    }
    const step = e.shiftKey ? 10 : 1;
    const moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
    const move = moves[e.key];
    if (!move) return;
    e.preventDefault();
    const r = c.rect;
    this.setCropRect(this.clampCropRect({ x: r.x + move[0], y: r.y + move[1], w: r.w, h: r.h }));
  }

  /** Print-pixel size of the area the photo has to fill on the current card. */
  cropSlotSize() {
    const tpl = this.selectedTemplate;
    if (this.templateUsesSlot(tpl)) {
      const inflate = this.slotInflationFor(tpl);
      return { width: tpl.photoSlot.size.width * inflate, height: tpl.photoSlot.size.height * inflate };
    }
    const landscape = !!(tpl && tpl.orientation === 'landscape');
    return {
      width: landscape ? this.printLongEdge : this.printShortEdge,
      height: landscape ? this.printShortEdge : this.printLongEdge
    };
  }

  /** Width:height of the card's photo area, for the "Card frame" crop shape. */
  cropCardRatio() {
    const slot = this.cropSlotSize();
    return slot.width / slot.height;
  }

  /**
   * Warn when a crop holds too few pixels to print sharply in its slot. Only
   * an actual crop is judged: the whole image is what the shopper uploaded,
   * and that was never warned about before the cropper existed.
   */
  updateCropQualityNote() {
    const c = this._crop;
    if (!c || !this.cropQualityNote) return;
    const r = c.srcRect;
    const isWhole = r.w >= c.source.width - 1 && r.h >= c.source.height - 1;
    let soft = false;
    if (!isWhole) {
      const slot = this.cropSlotSize();
      const tpl = this.selectedTemplate;
      const fitWhole = !!(tpl && tpl.source === 'blank' && this.blankFitMode === 'contain');
      // How far the crop is blown up to fill (or fit) the slot at 600 DPI.
      const blowUp = (fitWhole ? Math.min : Math.max)(slot.width / r.w, slot.height / r.h);
      soft = 600 / blowUp < 150;
    }
    this.cropQualityNote.classList.toggle('visible', soft);
  }

  setCropAspect(mode) {
    const c = this._crop;
    if (!c || c.drag) return;
    c.aspect = mode;
    c.ratio = mode === 'square' ? 1 : mode === 'card' ? this.cropCardRatio() : null;
    this.updateCropAspectButtons();
    if (c.ratio) this.setCropRect(this.fitRatioInRect(c.rect, c.ratio));
  }

  updateCropAspectButtons() {
    if (!this._crop) return;
    this.cropOverlay.querySelectorAll('[data-crop-aspect]').forEach(btn => {
      const active = btn.dataset.cropAspect === this._crop.aspect;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /** The largest box of `ratio` that fits inside `rect`, centred in it. */
  fitRatioInRect(rect, ratio) {
    const w = Math.min(rect.w, rect.h * ratio);
    const h = w / ratio;
    return { x: rect.x + (rect.w - w) / 2, y: rect.y + (rect.h - h) / 2, w, h };
  }

  rotateInCropper() {
    const c = this._crop;
    if (!c || c.drag) return;
    const rect = this.rotateRectCw(c.srcRect, c.source.height);
    c.rotation = (c.rotation + 90) % 360;
    c.source = this.buildCropSource(c.rotation);
    c.srcRect = rect;
    this.layoutCropStage();
    // A locked shape follows the card, not the image, so re-fit after the turn.
    if (c.ratio) this.setCropRect(this.fitRatioInRect(c.rect, c.ratio));
  }

  resetCropRect() {
    const c = this._crop;
    if (!c || c.drag) return;
    const full = { x: 0, y: 0, w: c.dispW, h: c.dispH };
    this.setCropRect(c.ratio ? this.fitRatioInRect(full, c.ratio) : full);
  }

  applyCrop() {
    const c = this._crop;
    if (!c || c.drag) return;
    const src = c.source;
    // Whole pixels, inside the source, at least 1x1.
    const x = Math.min(Math.max(Math.round(c.srcRect.x), 0), src.width - 1);
    const y = Math.min(Math.max(Math.round(c.srcRect.y), 0), src.height - 1);
    const w = Math.max(1, Math.min(Math.round(c.srcRect.w), src.width - x));
    const h = Math.max(1, Math.min(Math.round(c.srcRect.h), src.height - y));

    let cropped = src;
    if (x !== 0 || y !== 0 || w !== src.width || h !== src.height) {
      cropped = document.createElement('canvas');
      cropped.width = w;
      cropped.height = h;
      cropped.getContext('2d').drawImage(src, x, y, w, h, 0, 0, w, h);
    }

    this.uploadedPhoto = cropped;
    this._cropBakedRotation = c.rotation;
    this.cropRect = { x, y, w, h, rotation: c.rotation };
    this.closeCropper();

    // The turn is now part of the pixels; place the new image afresh.
    this.resetPosition();
    // Keep the browser-saved copy in step with what is on the card.
    if (this.saveImageToggle && this.saveImageToggle.checked && !this._photoFromSaved) {
      this.saveCurrentImage();
    }
  }

  renderPhotoPreview() {
    if (!this.selectedTemplate || !this.uploadedPhoto) return;

    const canvas = this.cardCanvas;
    const ctx = canvas.getContext('2d');

    canvas.style.display = 'block';
    canvas.style.cursor = 'move';
    const placeholder = document.getElementById(`photoPlaceholder-${this.id}`);
    if (placeholder) placeholder.style.display = 'none';

    // Hide static template preview to avoid double overlay
    if (this.selectedTemplatePreview) {
      this.selectedTemplatePreview.style.display = 'none';
    }

    // Check orientation for Step 2 preview
    const orientation = this.selectedTemplate?.orientation || 'landscape';
    if (orientation === 'landscape') {
      canvas.width = 600;
      canvas.height = 400;
    } else {
      canvas.width = 400;
      canvas.height = 600;
    }

    const tpl = this.selectedTemplate;
    const useSlot = this.templateUsesSlot(tpl);
    const isBlank = tpl.source === 'blank';

    const drawPhoto = () => {
      const scale = this.zoom / 100;
      let drawWidth, drawHeight, originX, originY;

      ctx.save();
      if (useSlot) {
        const sx = canvas.width / tpl.canvas.width;
        const sy = canvas.height / tpl.canvas.height;
        const slot = tpl.photoSlot;
        // Artwork cards: photoPosition drags the slot + photo together so the
        // user can align the photo region with the artwork's visible frame
        // when the JSON slot doesn't perfectly match the art.
        // Blank cards: the slot IS the printable panel (it defines the white
        // printer margin), so the clip stays put and only the photo pans.
        const blank = tpl.source === 'blank';
        const cx = slot.center.x * sx + (blank ? 0 : this.photoPosition.x);
        const cy = slot.center.y * sy + (blank ? 0 : this.photoPosition.y);
        const inflate = this.slotInflationFor(tpl);
        const sw = slot.size.width * sx * inflate;
        const sh = slot.size.height * sy * inflate;

        const slotAspect = sw / sh;
        const photoAspect = this.uploadedPhoto.width / this.uploadedPhoto.height;
        // Cover fills the slot and crops; contain (blank cards, "show whole
        // image") keeps the whole image visible, which is what a logo needs.
        const contain = blank && this.blankFitMode === 'contain';
        let baseW, baseH;
        if ((photoAspect > slotAspect) !== contain) {
          baseH = sh;
          baseW = baseH * photoAspect;
        } else {
          baseW = sw;
          baseH = baseW / photoAspect;
        }
        drawWidth = baseW * scale;
        drawHeight = baseH * scale;
        originX = cx + (blank ? this.photoPosition.x : 0);
        originY = cy + (blank ? this.photoPosition.y : 0);

        this.clipToPhotoSlot(ctx, slot, cx, cy, sw, sh);
        ctx.translate(originX, originY);
      } else {
        const aspectRatio = this.uploadedPhoto.height / this.uploadedPhoto.width;
        if (aspectRatio > 1) {
          drawHeight = canvas.height * scale;
          drawWidth = drawHeight / aspectRatio;
        } else {
          drawWidth = canvas.width * scale;
          drawHeight = drawWidth * aspectRatio;
        }
        originX = canvas.width / 2;
        originY = canvas.height / 2;
        ctx.translate(originX + this.photoPosition.x, originY + this.photoPosition.y);
      }

      ctx.rotate(this.rotation * Math.PI / 180);
      ctx.drawImage(this.uploadedPhoto, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      ctx.restore();
    };

    const compose = () => {
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // Blank cards have no art: white face, photo clipped to the inner panel.
      // For new-gift JPG overlays the slot area is opaque art, so the photo must
      // sit ON TOP of the overlay (clipped to the slot). For legacy PNG overlays
      // the slot is transparent so the photo sits UNDER the overlay.
      if (isBlank) {
        drawPhoto();
      } else if (useSlot) {
        ctx.drawImage(this.cachedOverlay, 0, 0, canvas.width, canvas.height);
        drawPhoto();
      } else {
        drawPhoto();
        ctx.drawImage(this.cachedOverlay, 0, 0, canvas.width, canvas.height);
      }
    };

    // Every render bumps a sequence number; an overlay that finishes loading
    // after a later render (or after a switch to a blank card, which never
    // loads one) must not paint over the newer frame.
    const seq = ++this._previewSeq;

    if (isBlank) {
      compose();
    } else if (this.cachedOverlay && this.cachedOverlay.src === tpl.overlayImage && this.cachedOverlay.complete) {
      compose();
    } else {
      // While overlay loads, paint white so we don't show a stale frame.
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      this.cachedOverlay = new Image();
      this.cachedOverlay.crossOrigin = 'anonymous';
      this.cachedOverlay.onload = () => {
        if (seq !== this._previewSeq || this.selectedTemplate !== tpl) return;
        compose();
      };
      this.cachedOverlay.src = tpl.overlayImage;
    }
  }

  startDrag(e) {
    if (!this.uploadedPhoto) return;
    this.isDragging = true;
    if (this.cardCanvas) {
      this.cardCanvas.style.cursor = 'grabbing';
    }

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    this.dragStart = {
      x: clientX - this.photoPosition.x,
      y: clientY - this.photoPosition.y
    };
    e.preventDefault();
  }

  drag(e) {
    if (!this.isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    this.photoPosition.x = clientX - this.dragStart.x;
    this.photoPosition.y = clientY - this.dragStart.y;

    this.renderPhotoPreview();
    e.preventDefault();
  }

  endDrag() {
    this.isDragging = false;
    if (this.cardCanvas) {
      this.cardCanvas.style.cursor = 'move';
    }
  }

  rotatePhoto() {
    this.rotation = (this.rotation + 90) % 360;
    this.renderPhotoPreview();
  }

  resetPosition() {
    this.photoPosition = { x: 0, y: 0 };
    this.zoom = 100;
    this.rotation = 0;
    if (this.zoomSlider) this.zoomSlider.value = 1;
    if (this.zoomSliderMobile) this.zoomSliderMobile.value = 1;
    if (this.zoomValue) this.zoomValue.textContent = '100%';
    this.renderPhotoPreview();
  }

  openModal() {
    if (!this._templatesRendered) {
      this.renderTemplates();
      this._templatesRendered = true;
    }
    // A fresh open is never an edit; openModalForEdit() re-sets the key after
    // calling this. Without the reset, an abandoned edit followed by a normal
    // add would silently delete the old cart line.
    this.editingLineKey = null;
    this._editExpectsPhoto = false;
    this._blankFrontConfirmed = false;
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Initialize button visibility for current step
    this.goToStep(this.currentStep);
  }

  /**
   * Reopen the customizer prefilled from a cart line's _card-state property
   * ("Edit card" on the cart page). When the card is re-added, the original
   * cart line is replaced.
   */
  openModalForEdit(stateJson, lineKey) {
    let state;
    try {
      state = JSON.parse(stateJson);
    } catch (error) {
      console.error('Unreadable card state on cart line:', error);
      return;
    }

    const template = this.templates.find(t => t.id === state.templateId);
    if (!template) {
      console.error('Card template no longer exists:', state.templateId);
      return;
    }

    this.openModal();
    this.selectTemplate(state.templateId);
    this.editingLineKey = lineKey || null;

    // Restore the message and formatting AFTER selectTemplate(), which clears
    // the editor whenever the card type changes.
    this.customMessage = state.message || '';
    if (this.messageEditor) {
      this.messageEditor.value = state.message || '';
      if (state.font) this.messageEditor.style.fontFamily = state.font;
      if (state.color) this.messageEditor.style.color = state.color;
      if (state.align) this.messageEditor.style.textAlign = state.align;
    }
    if (state.font && this.fontSelector) this.fontSelector.value = state.font;
    if (state.fontSize && this.fontSizeSelector) this.fontSizeSelector.value = state.fontSize;
    if (state.color && this.textColorPicker) this.textColorPicker.value = state.color;

    const sizeLabel = document.getElementById(`fontSizeLabel-${this.id}`);
    const sizeLabelMobile = document.getElementById(`fontSizeLabelMobile-${this.id}`);
    if (state.fontSize && sizeLabel) sizeLabel.textContent = `${state.fontSize}pt`;
    if (state.fontSize && sizeLabelMobile) sizeLabelMobile.textContent = `${state.fontSize}pt`;

    if (state.textBoxPosition) this.textBoxPosition = state.textBoxPosition;
    if (state.textBoxSize) this.textBoxSize = state.textBoxSize;
    this.updateTextBoxPosition();
    this.updateTextBoxSize();

    // The original photo can't be restored from the flattened print image, so
    // cards that had one re-enter at the photo step; the rest go straight to
    // the preview. A blank card's photo IS its front, so leaving that step
    // without one would replace a good print file with a white page: the
    // first Next press warns, a second press confirms the blank front.
    this._editExpectsPhoto = !!(state.hadPhoto && template.source === 'blank');
    this._blankFrontConfirmed = false;
    if (state.hadPhoto && template.canCustom) {
      this.goToStep(2);
    } else {
      this.goToStep(4);
    }
  }

  closeModal() {
    this.closeCropper();
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  goToStep(step) {
    const steps = this.progressBar.querySelectorAll('.card-progress-step');
    steps.forEach((stepEl, index) => {
      if (index + 1 < step) {
        stepEl.classList.add('completed');
        stepEl.classList.remove('active');
      } else if (index + 1 === step) {
        stepEl.classList.add('active');
        stepEl.classList.remove('completed');
      } else {
        stepEl.classList.remove('active', 'completed');
      }
    });

    // Scope selectors to this specific modal instance
    this.modal.querySelectorAll('.card-step-content').forEach(content => {
      content.classList.remove('active');
    });
    const targetStep = this.modal.querySelector(`.card-step-content[data-step="${step}"]`);
    if (targetStep) {
      targetStep.classList.add('active');
    }

    const prevBtn = document.querySelector(`[data-prev-step="${this.id}"]`);
    const nextBtn = document.querySelector(`[data-next-step="${this.id}"]`);
    const addBtn = document.querySelector(`[data-add-to-cart="${this.id}"]`);

    prevBtn.style.display = step === 1 ? 'none' : 'block';
    // Step 1 has no Next button: clicking a card advances automatically
    nextBtn.style.display = step === this.totalSteps || step === 1 ? 'none' : 'block';
    addBtn.style.display = step === this.totalSteps ? 'block' : 'none';

    // Step 2: Show photo section only if canCustom
    if (step === 2) {
      const photoSection = document.getElementById(`photoActionSection-${this.id}`);
      if (photoSection) {
        if (this.selectedTemplate && this.selectedTemplate.canCustom) {
          photoSection.style.display = 'block';
        } else {
          photoSection.style.display = 'none';
        }
      }
      if (this.stepHelp) {
        this.stepHelp.textContent = this.selectedTemplate && this.selectedTemplate.source === 'blank'
          ? 'Upload a photo or your logo to fill the front, or leave it blank and continue.'
          : 'Upload a photo to personalize your card.';
      }
      this.updateBlankControls();
      this.refreshSavedImageUi();
    }

    // Step 3: Set default message and update card orientation
    if (step === 3) {
      this.updateMessageCardOrientation();
      this.setDefaultMessage();
      this.centerTextBox();
      // Use requestAnimationFrame to ensure canvas has rendered its layout
      requestAnimationFrame(() => this.updateScaledFontSize());
    }

    // Step 4: Update summary, render final card, and update flip card message
    if (step === 4) {
      this.updateSummary();
      this.renderFinalCard();
      // The orientation class must be on the flip card before the message font
      // is scaled: the scale is derived from the card's rendered width, and
      // .flip-card.portrait is much narrower than the un-classed default.
      if (this.selectedTemplate) {
        const orientation = this.selectedTemplate.orientation || 'landscape';
        if (this.flipCard) {
          this.flipCard.classList.remove('landscape', 'portrait');
          this.flipCard.classList.add(orientation);
        }
        if (this.flipCardContainer) {
          this.flipCardContainer.classList.remove('landscape', 'portrait');
          this.flipCardContainer.classList.add(orientation);
        }
      }
      // Use requestAnimationFrame so the step pane and orientation styles have
      // been laid out before the flip card width is measured
      requestAnimationFrame(() => this.updateFlipCardMessage());
      // Reset flip card to front view
      if (this.flipCard) {
        this.flipCard.classList.remove('flipped');
        this.updateFlipButtons();
      }
    }

    this.currentStep = step;
  }

  nextStep() {
    if (this.currentStep === 1 && !this.selectedTemplate) {
      alert('Please select a card template');
      return;
    }

    if (this.currentStep === 1 && this.selectedTemplate && !this.selectedTemplate.canCustom) {
      this.goToStep(3);
      return;
    }

    if (this.currentStep === 2 && this._editExpectsPhoto && !this.hasPhoto && !this._blankFrontConfirmed) {
      this._blankFrontConfirmed = true;
      this.showNotification('This card had a photo. Add it again, or press Next once more to keep the front blank.', 'error');
      return;
    }

    if (this.currentStep < this.totalSteps) {
      this.goToStep(this.currentStep + 1);
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      if (this.currentStep === 3 && this.selectedTemplate && !this.selectedTemplate.canCustom) {
        this.goToStep(1);
        return;
      }
      this.goToStep(this.currentStep - 1);
    }
  }

  updateSummary() {
    if (this.summaryTemplate) {
      this.summaryTemplate.textContent = this.selectedTemplate ? this.templateDisplayName(this.selectedTemplate) : '-';
    }
    if (this.summaryPhoto) {
      this.summaryPhoto.textContent = this.hasPhoto ? 'Yes (included)' : 'No';
    }
    if (this.summaryPrice && this.productData) {
      const price = (this.productData.price / 100).toFixed(2);
      this.summaryPrice.textContent = `$${price}`;
    }
    // Store message for internal use (hidden, not displayed in summary)
    if (this.summaryMessage) {
      this.summaryMessage.textContent = this.customMessage ? this.customMessage : '';
      this.summaryMessage.style.display = 'none';
    }

    // Keep message preview hidden - message only shows on flip card back
    if (this.messagePreview) {
      this.messagePreview.style.display = 'none';
    }
  }

  /**
   * Draw the front of the card into an arbitrary canvas at an arbitrary scale.
   *
   * All geometry stays in the editor's logical space (400x600 portrait,
   * 600x400 landscape) because photoPosition, zoom and rotation are captured
   * in those units while the shopper drags. Scaling by kx/ky at the end means
   * the print file is a faithful enlargement of the preview the shopper
   * approved, rather than a recomposition that could shift their photo.
   *
   * kx and ky are applied separately because the logical box (2:3) and the
   * card stock (5.5:8.5) differ slightly in aspect. The preview has always
   * stretched the art to fill that box, so matching it keeps the printed card
   * identical to what was on screen.
   *
   * @param {HTMLCanvasElement} canvas - target, resized in place
   * @param {number} kx - horizontal logical-to-output scale
   * @param {number} ky - vertical logical-to-output scale
   * @returns {Promise<void>} resolves once the overlay art has been drawn
   */
  renderFrontTo(canvas, kx, ky) {
    return new Promise((resolve) => {
      const ctx = canvas.getContext('2d');

      // DIMENSION SETTING for Front Image
      // Check orientation
      const orientation = this.selectedTemplate?.orientation || 'landscape';

      const logicalWidth = orientation === 'landscape' ? 600 : 400;
      const logicalHeight = orientation === 'landscape' ? 400 : 600;

      canvas.width = Math.round(logicalWidth * kx);
      canvas.height = Math.round(logicalHeight * ky);

      // Everything below draws in logical units; the transform does the rest.
      ctx.setTransform(kx, 0, 0, ky, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      const tpl = this.selectedTemplate;
      const hasPhoto = this.uploadedPhoto && this.hasPhoto;
      const useSlot = hasPhoto && this.templateUsesSlot(tpl);
      const isBlank = !!(tpl && tpl.source === 'blank');

      const drawPhoto = () => {
        const scale = this.zoom / 100;
        let drawWidth, drawHeight, originX, originY;

        ctx.save();
        if (useSlot) {
          const sx = logicalWidth / tpl.canvas.width;
          const sy = logicalHeight / tpl.canvas.height;
          const slot = tpl.photoSlot;
          // Artwork: slot + photo move together with photoPosition (see
          // renderPhotoPreview). Blank: the clip is the printable panel and
          // stays put; only the photo pans.
          const blank = tpl.source === 'blank';
          const cx = slot.center.x * sx + (blank ? 0 : this.photoPosition.x);
          const cy = slot.center.y * sy + (blank ? 0 : this.photoPosition.y);
          const inflate = this.slotInflationFor(tpl);
          const sw = slot.size.width * sx * inflate;
          const sh = slot.size.height * sy * inflate;

          const slotAspect = sw / sh;
          const photoAspect = this.uploadedPhoto.width / this.uploadedPhoto.height;
          // Cover fills the slot; contain (blank "show whole image") fits it.
          const contain = blank && this.blankFitMode === 'contain';
          let baseW, baseH;
          if ((photoAspect > slotAspect) !== contain) {
            baseH = sh;
            baseW = baseH * photoAspect;
          } else {
            baseW = sw;
            baseH = baseW / photoAspect;
          }
          drawWidth = baseW * scale;
          drawHeight = baseH * scale;
          originX = cx + (blank ? this.photoPosition.x : 0);
          originY = cy + (blank ? this.photoPosition.y : 0);

          this.clipToPhotoSlot(ctx, slot, cx, cy, sw, sh);
        } else {
          const aspectRatio = this.uploadedPhoto.height / this.uploadedPhoto.width;
          if (aspectRatio > 1) {
            drawHeight = logicalHeight * scale;
            drawWidth = drawHeight / aspectRatio;
          } else {
            drawWidth = logicalWidth * scale;
            drawHeight = drawWidth * aspectRatio;
          }
          originX = logicalWidth / 2;
          originY = logicalHeight / 2;
        }

        // For useSlot the origin already includes photoPosition (slot dragged with photo).
        // For legacy the origin is canvas-center and photoPosition shifts the photo.
        const tx = useSlot ? originX : originX + this.photoPosition.x;
        const ty = useSlot ? originY : originY + this.photoPosition.y;
        ctx.translate(tx, ty);
        ctx.rotate(this.rotation * Math.PI / 180);
        ctx.drawImage(this.uploadedPhoto, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
        ctx.restore();
      };

      if (isBlank) {
        // No artwork: white face, then the photo (if any) clipped to the panel.
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, logicalWidth, logicalHeight);
        if (hasPhoto) drawPhoto();
        resolve();
        return;
      }

      const overlayImg = new Image();
      overlayImg.crossOrigin = 'anonymous';
      overlayImg.onload = () => {
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, logicalWidth, logicalHeight);
        // new-gift JPG: overlay underneath, photo (clipped) on top.
        // legacy PNG: photo underneath, overlay on top.
        if (useSlot) {
          ctx.drawImage(overlayImg, 0, 0, logicalWidth, logicalHeight);
          drawPhoto();
        } else {
          if (hasPhoto) drawPhoto();
          ctx.drawImage(overlayImg, 0, 0, logicalWidth, logicalHeight);
        }
        resolve();
      };
      overlayImg.onerror = (err) => {
        console.error('Failed to load overlay image for final render', err);
        // Resolve anyway to avoid blocking upload, though it will be missing overlay
        resolve();
      };
      overlayImg.src = this.selectedTemplate.overlayImage;
    });
  }

  /**
   * Render the on-screen final preview at 1:1 logical size (unchanged behaviour).
   */
  async renderFinalCard() {
    await this.renderFrontTo(this.finalPreviewCanvas, 1, 1);
    this.updateCardOptionPreview();
  }

  /**
   * Allocate an offscreen canvas at w x h, stepping down if the browser will
   * not honour it.
   *
   * iOS Safari caps total canvas area at roughly 16.7M pixels and a 600 DPI
   * card is 3300x5100 = 16.83M, just over the line. Past the cap the canvas
   * still allocates but silently drops every draw, which would upload a blank
   * card. So this paints a probe pixel and reads it back, halving each axis
   * until a draw actually sticks.
   *
   * @returns {{canvas: HTMLCanvasElement, width: number, height: number}|null}
   */
  createPrintCanvas(targetWidth, targetHeight) {
    for (let attempt = 0, scale = 1; attempt < 4; attempt++, scale /= 2) {
      const width = Math.round(targetWidth * scale);
      const height = Math.round(targetHeight * scale);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) continue;

      try {
        ctx.fillStyle = '#FF0000';
        ctx.fillRect(width - 1, height - 1, 1, 1);
        const probe = ctx.getImageData(width - 1, height - 1, 1, 1).data;
        if (probe[0] > 200 && probe[3] > 200) {
          if (scale < 1) {
            console.warn(
              `Print canvas limited to ${width}x${height}; this device refused ${targetWidth}x${targetHeight}.`
            );
          }
          return { canvas, width, height };
        }
      } catch (error) {
        console.warn('Print canvas probe failed, trying a smaller size.', error);
      }
    }
    return null;
  }

  /**
   * Encode a canvas to JPEG, stepping quality down until it fits a byte budget.
   *
   * The budget is for the whole upload, not one file: nginx caps
   * location /api/ at client_max_body_size 10M, which covers front + back +
   * form fields in a single multipart request. Budgeting each file separately
   * would let two large sides add up to a 413 before multer ever sees them.
   *
   * @param {HTMLCanvasElement} canvas
   * @param {number} [maxBytes] - defaults to the full request budget
   * @returns {Promise<Blob>}
   */
  canvasToJpegBlob(canvas, maxBytes = this.printMaxBytes) {
    const steps = this.printQualitySteps;
    const encode = quality => new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => (blob ? resolve(blob) : reject(new Error('Failed to convert canvas to blob'))),
        'image/jpeg',
        quality
      );
    });

    const attempt = async index => {
      const blob = await encode(steps[index]);
      if (blob.size <= maxBytes || index === steps.length - 1) {
        if (blob.size > maxBytes) {
          console.warn(`Card image is ${(blob.size / 1048576).toFixed(1)}MB at lowest quality.`);
        }
        return blob;
      }
      return attempt(index + 1);
    };

    return attempt(0);
  }

  /**
   * Render the front at print resolution and return it as a JPEG blob.
   *
   * @param {number} [maxBytes] - byte budget left over after the back image
   */
  async renderFrontPrintBlob(maxBytes) {
    const tpl = this.selectedTemplate;
    const orientation = tpl?.orientation || 'landscape';
    const logicalWidth = orientation === 'landscape' ? 600 : 400;
    const logicalHeight = orientation === 'landscape' ? 400 : 600;

    // Prefer the artwork's own dimensions so new-gift overlays are drawn at
    // native size with no resampling. Legacy templates carry no canvas block.
    const targetWidth = tpl?.canvas?.width
      || (orientation === 'landscape' ? this.printLongEdge : this.printShortEdge);
    const targetHeight = tpl?.canvas?.height
      || (orientation === 'landscape' ? this.printShortEdge : this.printLongEdge);

    const print = this.createPrintCanvas(targetWidth, targetHeight);
    if (!print) {
      console.warn('No print-size canvas available; falling back to preview resolution.');
      return this.canvasToJpegBlob(this.finalPreviewCanvas, maxBytes);
    }

    await this.renderFrontTo(print.canvas, print.width / logicalWidth, print.height / logicalHeight);
    let blob = await this.canvasToJpegBlob(print.canvas, maxBytes);
    if (maxBytes && blob.size > maxBytes && print.width > 1000) {
      // A full-panel photo (blank card, grainy shot) can exceed the request
      // budget even at the lowest quality step. Half resolution (300 DPI) is
      // still a good print and a quarter of the bytes; better than a 413.
      console.warn(`Card front is ${(blob.size / 1048576).toFixed(1)}MB; re-rendering at half resolution.`);
      const half = this.createPrintCanvas(Math.round(print.width / 2), Math.round(print.height / 2));
      if (half) {
        await this.renderFrontTo(half.canvas, half.width / logicalWidth, half.height / logicalHeight);
        blob = await this.canvasToJpegBlob(half.canvas, maxBytes);
      }
    }
    return blob;
  }

  openAIModal() {
    const messageText = this.messageEditor ? this.messageEditor.value.trim() : '';
    if (!messageText) {
      this.showNotification('Please write a message first!', 'error');
      return;
    }
    this.aiModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeAIModal() {
    this.aiModal.classList.remove('active');
    document.body.style.overflow = '';
    this.selectedCommands = [];
    document.querySelectorAll('.card-ai-pill.active').forEach(pill => {
      pill.classList.remove('active');
    });
  }

  toggleAIPill(pill) {
    const command = pill.dataset.command;
    if (pill.classList.contains('active')) {
      pill.classList.remove('active');
      this.selectedCommands = this.selectedCommands.filter(cmd => cmd !== command);
    } else {
      pill.classList.add('active');
      this.selectedCommands.push(command);
    }
    this.aiRewriteBtn.disabled = this.selectedCommands.length === 0;
  }

  async rewriteMessage() {
    if (this.selectedCommands.length === 0) {
      this.showNotification('Please select at least one option', 'error');
      return;
    }

    if (this.isAIProcessing) return;

    try {
      this.isAIProcessing = true;
      this.aiRewriteBtn.classList.add('loading');
      this.aiRewriteBtn.disabled = true;

      const recaptchaToken = await this.getRecaptchaToken();
      const giftCardType = this.getGiftCardType();

      const response = await fetch(this.aiConfig.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          giftCardType: giftCardType,
          userIdea: this.messageEditor.value,
          commands: this.selectedCommands,
          recaptchaToken: recaptchaToken
        })
      });

      if (!response.ok) throw new Error('AI API request failed');

      const data = await response.json();

      if (data.success) {
        this.customMessage = data.message;
        this.messageEditor.value = data.message;
        this.showNotification('Message enhanced successfully!', 'success');
        this.closeAIModal();
      } else {
        throw new Error('No enhanced message in response');
      }

    } catch (error) {
      console.error('AI Error:', error);
      this.showNotification('Failed to enhance message. Please try again.', 'error');
    } finally {
      this.isAIProcessing = false;
      this.aiRewriteBtn.classList.remove('loading');
      this.aiRewriteBtn.disabled = false;
    }
  }

  async getRecaptchaToken() {
    if (!this.aiConfig.recaptchaKey) {
      console.warn('No reCAPTCHA key configured');
      return '';
    }

    return new Promise((resolve) => {
      if (typeof grecaptcha === 'undefined') {
        console.warn('reCAPTCHA not loaded');
        resolve('');
        return;
      }

      grecaptcha.ready(() => {
        grecaptcha.execute(this.aiConfig.recaptchaKey, { action: 'generate_message' })
          .then(token => resolve(token))
          .catch(error => {
            console.error('reCAPTCHA error:', error);
            resolve('');
          });
      });
    });
  }

  getGiftCardType() {
    if (!this.selectedTemplate) return 'general';
    return this.selectedTemplate.type;
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `card-ai-notification ${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }

  /**
   * Generate UUID v4
   * @returns {string} UUID v4 string
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /**
   * Generate gift card ID using UUID v4 combined with epoch seconds
   * Format: {uuid}-{epochSeconds}
   * @returns {string} Combined ID
   */
  generateGiftCardId() {
    const uuid = this.generateUUID();
    const epochSeconds = Math.floor(Date.now() / 1000);
    return `${uuid}-${epochSeconds}`;
  }

  /**
   * Render the back of the card (message) to a canvas
   * @returns {Promise<Blob>} The rendered message as a JPEG blob
   */
  async renderBackCard() {
    return new Promise((resolve, reject) => {
      try {
        // DIMENSION SETTING for Back Image
        // Layout math stays in the original 72 DPI space (8.5" x 5.5"), which
        // keeps every font size, wrap width and text-box offset below exactly
        // as it was. The canvas itself is allocated at 600 DPI and scaled, so
        // the printed message is sharp instead of an upscaled 612px bitmap.
        const orientation = this.selectedTemplate?.orientation || 'landscape';
        const logicalWidth = orientation === 'landscape' ? 612 : 396;
        const logicalHeight = orientation === 'landscape' ? 396 : 612;

        const targetWidth = orientation === 'landscape' ? this.printLongEdge : this.printShortEdge;
        const targetHeight = orientation === 'landscape' ? this.printShortEdge : this.printLongEdge;

        const print = this.createPrintCanvas(targetWidth, targetHeight);
        const canvas = print ? print.canvas : document.createElement('canvas');
        if (!print) {
          canvas.width = logicalWidth;
          canvas.height = logicalHeight;
        }
        const ctx = canvas.getContext('2d');
        ctx.setTransform(canvas.width / logicalWidth, 0, 0, canvas.height / logicalHeight, 0, 0);

        // Fill with white background
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, logicalWidth, logicalHeight);

        // Get message and styling
        const messageText = this.messageEditor?.value || '';
        if (!messageText.trim()) {
          // No message, return white canvas
          this.canvasToJpegBlob(canvas).then(resolve, reject);
          return;
        }

        // Get styling from editor
        const font = this.fontSelector?.value || 'Arial';
        const fontSize = parseInt(this.fontSizeSelector?.value || '20', 10);
        const color = this.textColorPicker?.value || '#000000';
        const align = this.messageEditor?.style.textAlign || 'center';

        // Set up text rendering
        ctx.fillStyle = color;
        ctx.font = `${fontSize}pt ${font}`;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';

        // Calculate text box area based on position (percentage-based)
        const textBoxWidth = logicalWidth * 0.8;  // 80% of canvas width
        const maxWidth = textBoxWidth;
        const lineHeight = fontSize * 1.6;

        // Word wrap the text
        const lines = [];
        const paragraphs = messageText.split('\n');

        paragraphs.forEach(paragraph => {
          if (paragraph.trim() === '') {
            lines.push('');
            return;
          }

          const words = paragraph.split(' ');
          let currentLine = '';

          words.forEach(word => {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            const metrics = ctx.measureText(testLine);

            if (metrics.width > maxWidth && currentLine) {
              lines.push(currentLine);
              currentLine = word;
            } else {
              currentLine = testLine;
            }
          });

          if (currentLine) {
            lines.push(currentLine);
          }
        });

        // Calculate total text height
        const totalTextHeight = lines.length * lineHeight;

        // Calculate starting position based on text box position (centered)
        const centerX = (this.textBoxPosition.x / 100) * logicalWidth;
        const centerY = (this.textBoxPosition.y / 100) * logicalHeight;

        // Start Y position (vertically centered around the text box position)
        let y = centerY - (totalTextHeight / 2) + (lineHeight / 2);

        // Draw each line centered
        lines.forEach(line => {
          let x = centerX;

          if (align === 'left') {
            ctx.textAlign = 'left';
            x = centerX - (textBoxWidth / 2);
          } else if (align === 'right') {
            ctx.textAlign = 'right';
            x = centerX + (textBoxWidth / 2);
          } else {
            ctx.textAlign = 'center';
          }

          ctx.fillText(line, x, y);
          y += lineHeight;
        });

        // Convert canvas to blob
        this.canvasToJpegBlob(canvas).then(resolve, reject);

      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Upload card images (front and back) to custom API
   * Converts canvas elements to blobs for proper upload
   * @returns {Promise<Object>} API response with giftCardId and image URLs
   */
  async uploadCardImage() {
    try {
      // Keep the on-screen preview in sync, then render separate copies at
      // print resolution for the upload. The preview canvas keeps its original
      // size so the customizer looks and lays out exactly as before.
      await this.renderFinalCard();

      // Back first: it is text on white and always the smaller of the two, so
      // measuring it leaves an accurate budget for the front. Both travel in
      // one multipart request that nginx caps at 10MB in total.
      const backBlob = await this.renderBackCard();
      const frontBudget = this.printMaxBytes - backBlob.size;
      const frontBlob = await this.renderFrontPrintBlob(frontBudget);

      const totalMB = (frontBlob.size + backBlob.size) / 1048576;
      console.log(
        `Card images: front ${(frontBlob.size / 1048576).toFixed(2)}MB, ` +
        `back ${(backBlob.size / 1048576).toFixed(2)}MB, ` +
        `total ${totalMB.toFixed(2)}MB`
      );

      // Generate gift card ID (UUID v4 + epoch seconds)
      const giftCardId = this.generateGiftCardId();

      // Get orientation from selected template (default to landscape)
      const orientation = this.selectedTemplate?.orientation || 'landscape';

      // Create FormData with required fields for the API
      const formData = new FormData();
      formData.append('id', giftCardId);
      formData.append('orientation', orientation);
      formData.append('front', frontBlob, `${giftCardId}-front.jpg`);
      formData.append('back', backBlob, `${giftCardId}-back.jpg`);

      // Upload to API
      const uploadEndpoint = this.uploadApiEndpoint || 'https://giftcard.millicanpecan.com/api/create_giftcard';
      const uploadResponse = await fetch(uploadEndpoint, {
        method: 'POST',
        body: formData
      });

      if (!uploadResponse.ok) {
        // The API explains every rejection in an { error } body. Reporting only
        // the status code turned a one-line diagnosis into a guessing game, so
        // pass the message through when there is one.
        let detail = '';
        try {
          const failure = await uploadResponse.json();
          if (failure && failure.error) detail = `: ${failure.error}`;
        } catch (parseError) {
          // Non-JSON body (nginx 413/502 pages); the status alone has to do.
        }
        throw new Error(`Upload failed with status ${uploadResponse.status}${detail}`);
      }

      const result = await uploadResponse.json();
      if (!result.success) {
        throw new Error(result.error || 'API returned unsuccessful response');
      }

      return result;

    } catch (error) {
      console.error('Image upload error:', error);
      throw error;
    }
  }

  async addToCart() {
    if (!this.selectedTemplate || !this.productData) {
      alert('Please complete the customization');
      return;
    }

    const font = this.fontSelector.value || 'Arial';
    const fontSize = this.fontSizeSelector.value || '20';
    const color = this.textColorPicker.value || '#000000';
    const align = this.messageEditor.style.textAlign || 'left';
    const messageText = this.messageEditor.value || '';

    // Create styled HTML
    const messageHTML = messageText
      .split('\n')
      .map(line => `<p style="font-family: ${font}; font-size: ${fontSize}pt; color: ${color}; text-align: ${align}; margin: 0; line-height: 1.6;">${line || '&nbsp;'}</p>`)
      .join('');

    const addBtn = document.querySelector(`[data-add-to-cart="${this.id}"]`);

    try {
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="card-loading"></span> Processing...';

      // Determine if we need to upload to API
      // Upload if: user has a custom photo OR user has a message
      const hasMessage = messageText.trim() !== '';
      const hasCustomPhoto = this.selectedTemplate.canCustom && this.hasPhoto;
      // A blank card has no artwork to fall back on, so its front (photo or
      // plain white) is always rendered and uploaded for the printer.
      const isBlankCard = this.selectedTemplate.source === 'blank';
      const needsUpload = hasCustomPhoto || hasMessage || isBlankCard;

      let uploadResult = null;

      if (needsUpload) {
        // Render and upload happen within uploadCardImage (robust promise-based)
        addBtn.innerHTML = '<span class="card-loading"></span> Uploading...';
        uploadResult = await this.uploadCardImage();
      }

      // Prepare base properties. Public names (no underscore) render on the
      // cart page; underscore-prefixed ones are hidden there.
      const properties = {
        '_card-template': this.selectedTemplate.id,
        '_card-message-html': messageHTML,
        'Card Template': this.templateDisplayName(this.selectedTemplate),
      };

      if (hasMessage) {
        properties['Message'] = messageText;
      }

      // Everything needed to reopen the customizer prefilled from the cart
      // ("Edit card"). The photo itself can't round-trip, only the fact that
      // one was used, so the edit flow sends the user back through the photo
      // step when hadPhoto is set.
      properties['_card-state'] = JSON.stringify({
        templateId: this.selectedTemplate.id,
        message: messageText,
        font: font,
        fontSize: fontSize,
        color: color,
        align: align,
        textBoxPosition: this.textBoxPosition,
        textBoxSize: this.textBoxSize,
        hadPhoto: hasCustomPhoto
      });

      // Add upload result properties only if we uploaded
      if (uploadResult) {
        properties['_gift-card-id'] = uploadResult.giftCardId;
        properties['_orientation'] = uploadResult.orientation;
        properties['_front-image-url'] = uploadResult.images.front.url;
        properties['_back-image-url'] = uploadResult.images.back.url;
        properties['Preview URL'] = `https://giftcard.millicanpecan.com/preview/${uploadResult.giftCardId}`;
      }

      // Step 3: Add to Shopify cart
      addBtn.innerHTML = '<span class="card-loading"></span> Adding to cart...';
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: this.productData.variants[0].id,
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to add to cart');
      }

      // When editing an existing cart line, the updated card was just added
      // as a new line; remove the old one. Never fail the whole flow here:
      // the new card is already in the cart.
      if (this.editingLineKey) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: this.editingLineKey, quantity: 0 })
          });
        } catch (removeError) {
          console.error('Could not remove the old card line:', removeError);
        }
        this.editingLineKey = null;
      }

      // Success!
      this.showSuccessMessage();
      this.closeModal();

      // Trigger cart refresh
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      // Check if on cart page
      const isCartPage = window.location.pathname.includes('/cart');

      if (isCartPage) {
        // Refresh the page to show updated cart
        setTimeout(() => {
          window.location.reload();
        }, 1500); // Small delay for success message
      }

    } catch (error) {
      console.error('Cart error:', error);
      this.showErrorMessage(error.message || 'Failed to add card. Please try again.');
    } finally {
      addBtn.disabled = false;
      addBtn.innerHTML = '<span>✓</span> Add to Cart';
    }
  }

  showSuccessMessage() {
    const successOverlay = document.createElement('div');
    successOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    successOverlay.innerHTML = `
      <div style="background: white; padding: 40px; border-radius: 12px; text-align: center; max-width: 500px; animation: slideUp 0.3s ease-out;">
        <div style="width: 80px; height: 80px; background: #4caf50; border-radius: 50%; margin: 0 auto 24px; display: flex; align-items: center; justify-content: center; font-size: 48px;">✓</div>
        <h2 style="margin: 0 0 16px; color: #333; font-size: 28px;">Added to Cart!</h2>
        <p style="margin: 0 0 24px; color: #666; font-size: 16px;">Your personalized greeting card has been added.<br>Card uploaded and ready to print.</p>
        <button onclick="this.closest('div').parentElement.remove()" style="background: #d62e5e; color: white; border: none; padding: 14px 32px; border-radius: 6px; font-size: 16px; font-weight: 600; cursor: pointer;">Continue Shopping</button>
      </div>
    `;

    document.body.appendChild(successOverlay);
    setTimeout(() => successOverlay.remove(), 5000);
  }

  showErrorMessage(message) {
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #f44336;
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      z-index: 99999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    `;
    errorDiv.textContent = message;
    document.body.appendChild(errorDiv);
    setTimeout(() => errorDiv.remove(), 4000);
  }

  initializeEditor() {
    if (this.messageEditor) {
      this.messageEditor.style.fontFamily = "'Work Sans', sans-serif";
      this.messageEditor.style.fontSize = '18pt';
      this.messageEditor.style.color = '#000000';
      this.messageEditor.style.textAlign = 'center';
      this.messageEditor.value = '';
    }
  }

  updateCardOptionPreview() {
    if (!this.cardOptionImage || !this.finalPreviewCanvas) return;

    try {
      const dataUrl = this.finalPreviewCanvas.toDataURL('image/jpeg', 0.8);
      this.cardOptionImage.src = dataUrl;
    } catch (error) {
      console.error('Failed to update card preview:', error);
    }
  }
}

// The theme can load this script after DOMContentLoaded has already fired,
// in which case a DOMContentLoaded-only bootstrap never runs.
function initGreetingCardCustomizers() {
  document.querySelectorAll('[data-card-id]').forEach(element => {
    const uniqueId = element.dataset.cardId;
    const productHandle = element.dataset.productHandle;
    // Registry so other scripts (and the dev harness) can reach an instance.
    window.greetingCardCustomizers = window.greetingCardCustomizers || {};
    window.greetingCardCustomizers[uniqueId] = new GreetingCardCustomizer(uniqueId, productHandle);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGreetingCardCustomizers);
} else {
  initGreetingCardCustomizers();
}